{
  "accountDropdown": {
    "changeAccount": "Account wechseln",
    "createRuleNew": "Neue Preisregel",
    "filter": "Filter",
    "loading": "Wird geladen",
    "profile": "Profil",
    "searchHotelPlaceholder": "Hotel suchen...",
    "title": "Account"
  },
  "action": {
    "decrease": "Verringern",
    "delete": "Löschen",
    "duplicate": "Duplizieren",
    "increase": "Erhöhen",
    "rename": "Umbenennen",
    "save": "Speichern",
    "saveChanges": "Änderungen speichern",
    "setAsDefault": "Als Standard festlegen"
  },
  "activated": "Aktiviert",
  "activityLog": {
    "affectedDate": "Betroffenes Datum",
    "affectedDateTooltip": "Änderungszeitraum auf “Vergangene 6 Monate“, setzen, um alle geloggten Änderungen für das betroffene Datum zu sehen.",
    "changeTime": "Änderungszeit",
    "details": "Details",
    "emptyTable": "Keine Einträge gefunden. Ändern Sie den Änderungszeitraum um mehr Ergebnisse anzuzeigen.",
    "filenamePrefix": "activity-log",
    "loggedDatesTooltip": "Aus Datenschutzgründen werden Logs nach 6 Monaten gelöscht.",
    "maxExportElementsReached": "Zu viele Elemente ausgewählt. Bitte passen Sie Ihre Filter an, um die Auswahl auf weniger als {max} Elemente zu reduzieren, bevor Sie exportieren.",
    "ranges": {
      "last3Months": "Letzten 3 Monate",
      "last6Months": "Letzten 6 Monate",
      "last7Days": "Letzten 7 Tage",
      "lastMonth": "Letzter Monat",
      "thisMonth": "Dieser Monat"
    },
    "schemaMapping": {
      "rateRulesV1": {
        "activate": "Preisregel \"{name}\" wurde aktiviert.",
        "deactivate": "Preisregel \"{name}\" wurde deaktiviert.",
        "delete": "Preisregel \"{name}\" wurde gelöscht.",
        "edit": "Preisregel \"{name}\" wurde bearbeitet."
      },
      "ratesV1": {
        "rateFromTo": "von {rateFrom} auf {rateTo}",
        "rateTo": "auf {rateTo}"
      },
      "restrictionsV1": {
        "ctaAdded": "CTA hinzugefügt",
        "ctaRemoved": "CTA entfernt",
        "ctdAdded": "CTD hinzugefügt",
        "ctdRemoved": "CTD entfernt",
        "maxLos": "MaxLOS entfernt | MaxLOS auf {n} | MaxLOS auf {n}",
        "minLos": "MinLOS entfernt | MinLOS auf {n} | MinLOS auf {n}"
      },
      "resyncdataV1": {
        "error": "Raten und Restriktionen wurden nicht synchronisiert. Weitere Details finden Sie im Fehlerprotokoll auf der Manage Seite.",
        "success": "Die Raten und Restriktionen wurden für die nächsten zwei Jahre erfolgreich synchronisiert.",
        "trigger": "Resynchronisierung wurde gestartet. Der Abschluss des Prozesses wird in ein paar Minuten protokolliert."
      }
    },
    "title": "Aktivitätsprotokoll",
    "tooManyLogs": "{number} mehr zu zeigen. Bitte betroffenes Datum angeben!",
    "type": "Art der Änderung",
    "types": {
      "rateRules": "Preisregeln",
      "rates": "Rate",
      "restrictions": "Restriktionen",
      "resyncdata": "Resync"
    },
    "typesPerContent": {
      "resyncdataV1": {
        "error": "Resync - Fehler",
        "success": "Resync - Erfolg",
        "trigger": "Resync - Start"
      }
    },
    "user": "Benutzer"
  },
  "add": "Hinzufügen",
  "administration": {
    "inboundData": {
      "applyFilter": "Filter anwenden",
      "arrival": "Ankunft",
      "booked": "Booked",
      "cancelled": "Cancelled",
      "comparison": {
        "downloadTemplate": "Vorlage herunterladen",
        "error": {
          "dateParsingError": "{count} Datumswerte konnten nicht gelesen werden. Bitte überprüfe deine Datumswerte.",
          "generic": "Vergleichsergebnisse konnten nicht geladen werden. Bitte versuche es später erneut."
        },
        "instructions": {
          "fields": "Datum, Revenue, verkaufte Zimmer enthalten.",
          "intro": "Bevor Sie Ihre Datei hochladen, beachten Sie bitte:",
          "maxFileSize": "Die maximale Dateigröße beträgt 10 MB.",
          "requiredFields": "Ihre .csv- oder .xlsx-Datei muss die Felder",
          "revenueFormat": "Das Revenue muss im gleichen Format vorliegen, wie in der untenstehenden Vorlage angegeben."
        },
        "loading": "Vergleichsergebnisse werden geladen…",
        "startNewComparison": "Neuen Vergleich starten",
        "step1": {
          "message": "Laden Sie Ihre Datei hoch."
        },
        "step2": {
          "compare": "Vergleichen",
          "excludedRooms": "Ausgeschlossene Zimmer",
          "header": "Kopfzeile ist in der Datei enthalten",
          "message": "Alle erforderlichen Felder zuordnen.",
          "notMapped": "Nicht zugeordnet",
          "settings": "Einstellungen"
        },
        "table": {
          "date": "Datum",
          "pmsRevenue": "PMS Umsatz",
          "pmsRoomsSold": "PMS verkaufte Zimmer",
          "rbRevenue": "RB Umsatz",
          "rbRoomsSold": "RB verkaufte Zimmer",
          "revenueDiff": "Umsatz Diff.",
          "roomsSoldDiff": "Verkaufte Zimmer Diff."
        }
      },
      "confirmed": "Confirmed",
      "creation": "Erstellung",
      "dataTableColumnTitle": {
        "arrivalDate": "Ankunfsdatum",
        "blockedUntil": "Gesperrt bis",
        "blockId": "Block-ID",
        "channel": "Channel",
        "countryCode": "Ländercode",
        "creationDate": "Erstellungsdatum",
        "departureDate": "Abreise Datum",
        "excluded": "Ausgeschlossen",
        "isRoom": "Ist Zimmer",
        "mainResId": "Haupt ResID",
        "name": "Name",
        "numberOfAdults": "Anzahl Erwachsene",
        "numberOfChildren": "Anzahl Kinder",
        "numberOfInfants": "Anzahl Säuglinge",
        "reservationId": "Externe Res-ID",
        "roomNumber": "Zimmernummer",
        "roomType": "Zimmer-Typ",
        "segment": "Segment",
        "status": "Status",
        "total": "Gesamt"
      },
      "dataTabs": {
        "roomStats": {
          "description": "Room stats re-computation",
          "recompute": "Re-compute"
        },
        "title": {
          "blocks": "Blockierungen",
          "comparison": "Reservierungen vergleichen",
          "inventory": "Inventar",
          "reservations": "Reservierungen",
          "roomStats": "Room Stats"
        }
      },
      "delete": "Löschen",
      "deleteAll": "Alle",
      "deleteFiltered": "Gefilterte",
      "deleteSelected": "Gewählte",
      "departure": "Abreise",
      "filterDropdown": {
        "noneSelected": "Keine",
        "selected": "{count} ausgewählt"
      },
      "filters": {
        "blockId": "Block-ID",
        "dateBy": "Daten filtern nach",
        "dateRange": "Datumsbereich",
        "excludedRooms": "Ausgeschlossene",
        "filter": "Filter",
        "reservationId": "Reservierungs-ID",
        "roomType": "Zimmertyp",
        "status": "Status"
      },
      "hide": "Ausblenden",
      "inboundData": "Eingehende Daten",
      "inventory": {
        "blocked": "Blockiert (Block verfügbar)",
        "date": "Datum",
        "excluded": "Ausgeschlossen",
        "outOfOrder": "Außer Betrieb",
        "physical": "Physisch",
        "roomType": "Zimmer-Typ"
      },
      "modal": {
        "cleanAll": {
          "message": "Um die Reservierungen zu löschen, gib bitte den folgenden Text in das Eingabefeld unten ein: {companyName}",
          "title": "Reservierungen löschen"
        },
        "cleanFiltered": {
          "message": {
            "blocks": "Sind Sie sicher, dass Sie die ausgewählten Blockierungen leeren wollen? Dies führt zur Löschung aller Blockierungen, die den eingestellten Filtern entsprechen.",
            "reservations": "Sind Sie sicher, dass Sie die gefilterten Reservierungen leeren wollen? Dies führt zur Löschung aller Reservierungen, die den eingestellten Filtern entsprechen, einschließlich aller ihrer Zimmer"
          },
          "title": {
            "blocks": "Blockierungen leeren",
            "reservations": "Reservierungen leeren"
          }
        },
        "cleanSelected": {
          "message": {
            "blocks": "Sind Sie sicher, dass Sie die ausgewählten Blockierungen leeren wollen?",
            "reservations": "Sind Sie sicher, dass Sie die ausgewählten Reservierungen leeren wollen?"
          },
          "title": {
            "blocks": "Blockierungen leeren",
            "reservations": "Reservierungen leeren"
          }
        }
      },
      "noShow": "No Show",
      "option": "Option",
      "optionNoDeduction": "Option no deduction",
      "reservationsImport": {
        "addToDatabase": "Zur Datenbank hinzufügen",
        "cancelImport": "Import abbrechen",
        "errorMessage": "Reservierungen konnten nicht hochgeladen werden. Bitte versuchen Sie es später erneut.",
        "step1": {
          "downloadTemplate": "Vorlage herunterladen",
          "message1": "Bevor Sie Ihre Datei hochladen, beachten Sie bitte:",
          "message2": {
            "part1": "Ihre .csv-Datei muss die Felder ",
            "part2": "Reservierungs-ID, Anzahl der Erwachsenen, Anzahl der Kinder, Zimmertyp, Buchungsdatum, Ankunfsdatum, Abreise Datum, Status und Gesamtbetrag enthalten."
          },
          "message3": "Die Werte für die Felder, die Datum, Betrag oder Status enthalten, müssen im gleichen Format vorliegen, wie wir es in unserer Vorlage angegeben haben.",
          "message4": "Nachdem die Datei hochgeladen wurde, ordnen Sie bitte alle erforderlichen Felder zu."
        },
        "step2": {
          "import": "Importieren",
          "invalidData": "Ungültiger Wert \"{value}\" im Feld \"{field}\" gefunden. Wenn Ihre Datei Kopfzeilen enthält, überprüfen Sie bitte das Checkbox \"Kopfzeile ist in der Datei enthalten\".",
          "message": "Ordnen Sie alle erforderlichen Felder zu. Überprüfen Sie anschließend die Daten und führen Sie sie mit der Datenbank zusammen.",
          "notMapped": "Nicht zugeordnet",
          "settings": {
            "message": "Kopfzeile ist in der Datei enthalten",
            "title": "Settings"
          }
        },
        "successMessage": "Reservierungen erfolgreich hochgeladen.",
        "title": "Importreservierungen"
      },
      "show": "Anzeigen",
      "status": "Status",
      "stay": "Aufenthalt"
    },
    "userManagement": {
      "aboutUser": "ÜBER BENUTZER",
      "addNewUser": "Neuen Benutzer hinzufügen",
      "addUser": "Benutzer hinzufügen",
      "adminPermissions": "ADMIN-BERECHTIGUNGEN",
      "admins": "ADMINS",
      "areYouSureThatYouWantToRemoveCompany": "Sind Sie sicher, dass sie {firstname} {lastname} aus dem Hotel {companyName} ({companyId}) entfernen möchten?",
      "assignCompany": "HOTEL ZUWEISEN",
      "assignedCompanies": "ZUGEORDNETE HOTELS",
      "assignNewCompany": "NEUES HOTEL ZUWEISEN",
      "backToUsers": "Zurück zu den Benutzern",
      "beCareful": "Vorsicht",
      "cancelled": "Annulliert",
      "changeStatus": "Status ändern",
      "changeStatusConfirmation": "Sind Sie sicher, dass Sie {fullname} {action} möchten?",
      "companies": "Hotels",
      "company": "Hotel",
      "companyCount": "Anzahl der Hotels",
      "customers": "KUNDEN",
      "definite": "Fix",
      "delete": "LÖSCHEN",
      "disable": "deaktivieren",
      "disabled": "Deaktiviert",
      "disableWarningMessage": "wenn Sie dieses Benutzerkonto deaktivieren, kann sich der Benutzer nicht mehr bei RateBoard anmelden.  Sie können diese Aktion später wieder rückgängig machen.",
      "email": "E-Mail",
      "enable": "aktivieren",
      "enabled": "Aktiviert",
      "error": {
        "duplicateEmail": "Benutzer mit E-Mail existiert bereits",
        "existingInvitation": "Benutzer wurde schon eingeladen.",
        "existingInvitationToCompany": "Benutzer wurde zu diesem Hotel schon eingeladen.",
        "fillAll": "Bitte fülle alle Felder aus."
      },
      "expired": "Abgelaufen",
      "firstname": "Vorname",
      "id": "ID",
      "language": "Sprache",
      "lastname": "Nachname",
      "loading": "Ladet...",
      "makeAdminWarning": " die Aktivierung der Admin-Berechtigungen erlaubt dem Benutzer den Zugriff auf alle Konten und die Durchführung von Änderungen. Vergewissern Sie sich, dass Sie den richtigen Benutzer ausgewählt haben, bevor Sie fortfahren.",
      "manageAdmins": "ADMINS VERWALTEN",
      "manageAdminsModal": "Admins verwalten",
      "mfaRequired": "2FA",
      "none": "-",
      "openInvite": "OFFENE EINLADUNG",
      "openInvites": "Offene Einladungen",
      "prospect": "Voraussichtlich",
      "rateboardUsers": "RateBoard Benutzer",
      "remove": "ENTFERNEN",
      "removeCompany": "Hotel entfernen",
      "resendInvite": "EINLADUNG WIEDERHOLEN",
      "role": "ROLLE",
      "searchFor": "Suchen nach",
      "searchPlaceholder": "Suchen...",
      "seeAll": "Alle anzeigen",
      "selectCompany": "Hotel auswählen",
      "selectUser": "Wählen Sie einen Benutzer, den Sie zu einem ADMIN machen möchten",
      "sendInvite": "Einladung senden",
      "status": "STATUS",
      "statusHeader": "Status",
      "user": "Benutzer",
      "userId": "Benutzer-ID",
      "username": "Benutzername",
      "users": "Benutzer"
    }
  },
  "alert": {
    "message": {
      "error": "Etwas ist schiefgelaufen.",
      "success": "Ihre Anfrage wurde erfolgreich verarbeitet."
    },
    "title": {
      "error": "Fehler!",
      "success": "Erfolgreich!"
    }
  },
  "analyse": {
    "comparison": {
      "chartTitles": {
        "occupancy": "Entwicklung Auslastung",
        "revenue": "Entwicklung Umsatz"
      },
      "filters": {
        "label": {
          "main": "Hauptzeitraum",
          "reference": "Referenzzeitraum"
        }
      },
      "occupancyChart": {
        "tooltip": {
          "daysBeforeEnd": "Tage vor Ende",
          "dba": "DBA",
          "occupancy": "@:analyse.filters.kpi.occupancy"
        }
      },
      "revenueChart": {
        "tooltip": {
          "adr": "@:analyse.filters.kpi.adr",
          "daysBeforeEnd": "Tage vor Ende",
          "dba": "DBA",
          "revenue": "@:analyse.filters.kpi.revenue",
          "revPar": "@:analyse.filters.kpi.revpar"
        }
      },
      "slider": {
        "adr": "@:analyse.filters.kpi.adr",
        "occupancy": "@:analyse.filters.kpi.occupancy",
        "revPar": "@:analyse.filters.kpi.revpar"
      },
      "table": {
        "adr": "@:analyse.filters.kpi.adr",
        "adrReference": "@:analyse.filters.kpi.adr Ref.",
        "daysBeforeEndDate": "Tage vor Enddatum",
        "dba": "DBA",
        "occupancy": "@:analyse.filters.kpi.occupancy",
        "occupancyReference": "@:analyse.filters.kpi.occupancy Ref.",
        "revenue": "@:analyse.filters.kpi.revenue",
        "revenueReference": "@:analyse.filters.kpi.revenue Ref.",
        "revpar": "@:analyse.filters.kpi.revpar",
        "revparReference": "@:analyse.filters.kpi.revpar Ref."
      },
      "title": "Zeiträume vergleichen",
      "tooltips": {
        "charts": {
          "occupancy": "Entwicklung der Auslastung im zeitlichen Verlauf bis hin zum angegebenen letzten Tag des Zeitraums.",
          "revenue": "Entwicklung der Umsatz-KPIs im zeitlichen Verlauf bis hin zum angegebenen letzten Tag des Zeitraums."
        },
        "infoTiles": {
          "adr": "Aktuelle ADR (Average Daily Rate) im Durchschnitt für den gewählten Hauptzeitraum. Zusätzlich siehst du die Abweichung zum gewählten Referenzzeitraum.",
          "forecast": "Prognose der erwarteten Zimmeranzahl und Auslastung im zukünftigen Hauptzeitraum. Der Forecast wird für die nächsten 12 Monate generiert und ist nur bei ausreichender Datenlage verfügbar.",
          "occupancy": "Aktuelle Auslastung für den gewählten Hauptzeitraum (Gesamtanzahl verkaufter Zimmer und durchschnittliche Auslastung in %). Zusätzlich siehst du die Abweichung zum gewählten Referenzzeitraum.",
          "revenue": "Aktueller Umsatz für den gewählten Hauptzeitraum. Zusätzlich siehst du die Abweichung zum gewählten Referenzzeitraum.",
          "revPar": "Aktueller RevPar (Revenue Per Available Room) im Durchschnitt für den gewählten Hauptzeitraum. Zusätzlich siehst du die Abweichung zum gewählten Referenzzeitraum.",
          "vacantRooms": "Gesamte Anzahl der noch verfügbaren Zimmer(-nächte) für den gewählten Hauptzeitraum. Zusätzlich siehst du die Abweichung zum gewählten Referenzzeitraum."
        }
      }
    },
    "filters": {
      "distribution": {
        "channels": "Kanäle",
        "countries": "Länder",
        "room_category": "Zimmerkategorien",
        "room_type": "Zimmertypen",
        "segment_categories": "Segmentkategorien",
        "segments": "Segmente"
      },
      "filter": {
        "channels": "KANÄLE",
        "complimentary": "Freinächte",
        "countries": "LÄNDER",
        "group": "Gruppen",
        "not_set": "Keine",
        "pickup": "PICKUP",
        "pickup_14days": "14 Tage",
        "pickup_1day": "1 Tag",
        "pickup_30days": "30 Tage",
        "pickup_3days": "3 Tage",
        "pickup_60days": "60 Tage",
        "pickup_7days": "7 Tage",
        "pickup_90days": "90 Tage",
        "room_categories": "ZIMMERKATEGORIEN",
        "room_types": "ZIMMERTYPEN",
        "segment_categories": "SEGMENTKATEGORIEN",
        "segments": "SEGMENTE"
      },
      "kpi": {
        "adr": "ADR",
        "occupancy": "Auslastung",
        "revenue": "Umsatz",
        "revpar": "RevPar"
      },
      "labels": {
        "distribution": "Verteilung",
        "filter": "Filter",
        "kpi": "Kennzahl",
        "reference1": "1. Referenz",
        "reference2": "2. Referenz"
      },
      "reference": {
        "budget": "BUDGET",
        "final_2_years_ago": "FINAL 2 JAHRE VORHER",
        "final_2_years_ago_same_date": "Selbes Datum final 2J",
        "final_2_years_ago_same_day_week": "Selber Wochentag final 2J",
        "final_last_year": "FINAL VORJAHR",
        "final_last_year_same_date": "Selbes Datum final 1J",
        "final_last_year_same_day_week": "Selber Wochentag final 1J",
        "same_date": "Selbes Datum",
        "same_day_week": "Selber Wochentag",
        "same_time_2_years_ago": "SELBE ZEIT 2 JAHRE VORHER",
        "same_time_2_years_ago_same_date": "Selbes Datum YTD 2J",
        "same_time_2_years_ago_same_day_week": "Selber Wochentag YTD 2J",
        "same_time_last_year": "SELBE ZEIT VORJAHR",
        "same_time_last_year_same_date": "Selbes Datum YTD 1J",
        "same_time_last_year_same_day_week": "Selber Wochentag YTD 1J",
        "show_budget": "Budget anzeigen"
      }
    },
    "hotel": {
      "analyseChart": {
        "legend": {
          "bar": {
            "pickup": {
              "cancellations": "Storniert",
              "confirmations": "Bestätigt",
              "otb": "OTB"
            },
            "reference1": "(Referenz 1)",
            "reference2": "(Referenz 2)"
          },
          "budget": "Budget",
          "event": {
            "primary": "Event",
            "reference1": "Event (Referenz 1)",
            "reference2": "Event (Referenz 2)"
          },
          "forecast": "{kpi} Forecast",
          "forecastTooltip": "Die Prognose für die nächsten 12 Monate wird nur angezeigt, wenn nach übergeordneten Kriterien die Datengrundlage ausreichend ist. Die hinterlegte Schattierung der Linie steht für den wahrscheinlichen Schwankungsbereich im Forecast.",
          "line": {
            "primary": "Aktive Rate",
            "reference1": "Aktive Rate (Referenz 1)",
            "reference2": "Aktive Rate (Referenz 2)"
          }
        },
        "noData": "Keine Daten verfügbar"
      },
      "detail": {
        "header": "@:analyse.hotel.detail.headerNoReference im Vergleich zu <b>{referenceDate}</b>",
        "headerNoReference": "Details für <b>{date}</b>",
        "headerWithSecond": "@:analyse.hotel.detail.header und <b>{secondReferenceDate}</b>",
        "placeholder": "Klicke auf ein Datum im Diagramm, um Details anzuzeigen",
        "tooltip": {
          "developmentChart": "Entwicklung der KPI's im zeitlichen Verlauf abhängig von den DBA (days before arrival).",
          "rateUpdatesChart": "Aktive Raten (das sind jene, die tatsächlich versendet wurden) im zeitlichen Verlauf pro Zimmerkategorie."
        }
      },
      "developmentChart": {
        "availableRooms": "Verfügbare Zimmer",
        "availableRooms1": "Verfügbare Zimmer (@:analyse.hotel.gridItems.reference1)",
        "availableRooms2": "Verfügbare Zimmer (@:analyse.hotel.gridItems.reference2)",
        "forecast": "Forecast",
        "roomsSold": "Verkaufte Zimmer",
        "roomsSold1": "Verkaufte Zimmer (@:analyse.hotel.gridItems.reference1)",
        "roomsSold2": "Verkaufte Zimmer (@:analyse.hotel.gridItems.reference2)",
        "title": "Entwicklung",
        "tooltip": {
          "adr": "@:analyse.filters.kpi.adr",
          "availableRooms": "Verfügbare Zimmer",
          "dba": "Tage vor Anreise",
          "occupancy": "@:analyse.filters.kpi.occupancy",
          "revenue": "@:analyse.filters.kpi.revenue",
          "revPar": "@:analyse.filters.kpi.revpar",
          "roomsSold": "Verkaufte Zimmer"
        },
        "vacantRooms": "Freie Zimmer"
      },
      "gridItems": {
        "adr": "@:analyse.filters.kpi.adr",
        "availableRooms": "Verfügbare Zimmer",
        "forecast": "Forecast",
        "occupancy": "@:analyse.filters.kpi.occupancy",
        "reference1": "1. Referenz",
        "reference2": "2. Referenz",
        "revenue": "@:analyse.filters.kpi.revenue",
        "revPar": "@:analyse.filters.kpi.revpar",
        "roomNights": "Zimmernächte"
      },
      "indicator": "Details oben",
      "infoTiles": {
        "adr": "Aktueller ADR (Average Daily Rate) für den gewählten Tag. Zusätzlich siehst du die  Abweichung zur gewählten Referenz.",
        "forecast": "{kpi} Forecast",
        "noData": "Keine Daten verfügbar",
        "tooltip": {
          "forecast": "Die Prognose für den gewählten Tag ist bei ausreichender Datenlage verfügbar für die Kennzahl Umsatz und Auslastung (voraussichtlich verkaufte Zimmer). Der Forecast wird generiert für die nächsten 12 Monate.",
          "forecastNoData": "Forecast für die Vergangenheit nicht berechnet",
          "revenue": "Aktueller Logis-Umsatz für den gewählten Tag. Zusätzlich siehst du die  Abweichung zur gewählten Referenz.",
          "revpar": "Aktueller RevPAR (Revenue Per Available Room) für den gewählten Tag. Zusätzlich siehst du die  Abweichung zur gewählten Referenz.",
          "roomsSold": "Aktuelle Auslastung für den gewählten Tag. Zusätzlich siehst du die  Abweichung zur gewählten Referenz.",
          "vacantRooms": "Anzahl der noch verfügbaren Zimmer für den gewählten Tag. Zusätzlich siehst du die  Abweichung zur gewählten Referenz."
        }
      },
      "rateUpdatesChart": {
        "title": "Ratenänderungen"
      },
      "showSentRate": "Aktive Rate anzeigen",
      "title": "Hoteldaten",
      "tooltip": {
        "budget": "Budget",
        "forecast": "Forecast",
        "lastRateSent": "Aktive Rate",
        "total": "Gesamt"
      }
    },
    "table": {
      "activeRate": "Aktive Rate",
      "date": "Datum",
      "firstDifference": "1. Unterschied",
      "firstReference": "@:analyse.filters.labels.reference1",
      "secondDifference": "2. Unterschied",
      "secondReference": "@:analyse.filters.labels.reference2",
      "summary": "Zusammenfassung",
      "total": "Gesamt"
    }
  },
  "assistant": {
    "actions": {
      "cancel": "Abbrechen",
      "close": "Schließen",
      "collapse": "Verkleinern",
      "delete": "Löschen",
      "download": "Exportieren",
      "edit": "Bearbeiten",
      "expand": "Vergrößern",
      "newChat": "Neuer Chat",
      "rename": "Umbenennen",
      "submit": "Senden",
      "update": "Aktualisieren"
    },
    "chat": {
      "actions": {
        "send": "Senden",
        "sending": "Wird gesendet..."
      },
      "disclaimer": {
        "linkText": "Das ist KI.",
        "text": "Sie kann Fehler machen, sieht und kennt nicht alle Gegebenheiten - daher überprüfe die Aussagen und vertraue auf dein eigenes Urteilsvermögen."
      },
      "emptyState": {
        "descriptions": {
          "first": "Der KI-Revenue Manager analysiert deine Daten, den Markt, Forecasts und vieles mehr, um dir dabei zu helfen, fundierte Entscheidungen zu treffen - stell ihn dir als Sparringspartner vor, der dir Einblicke und Empfehlungen im Revenue Management liefert.",
          "fourth": "Du behältst die Kontrolle - der KI-Revenue Manager nimmt keine eigenständigen Änderungen in RateBoard vor.",
          "second": "Du kennst dein Haus am besten. Der KI-Revenue Manager arbeitet mit den verfügbaren Daten und kennt nicht immer alle für dein Haus relevanten Aspekte — die Entscheidung liegt am Ende immer bei dir.",
          "third": "Du kannst jederzeit nach Tabellen oder Diagrammen fragen, um Daten besser zu veranschaulichen."
        }
      },
      "message": {
        "chart": {
          "legend": {
            "clickToHide": "Klicken zum Ausblenden",
            "clickToShow": "Klicken zum Anzeigen"
          }
        },
        "download": {
          "chart": {
            "png": "Als PNG herunterladen"
          },
          "table": {
            "csv": "Als CSV herunterladen"
          }
        },
        "error": {
          "actions": {
            "retryPrevious": "Vorherige Frage erneut senden"
          },
          "descriptions": {
            "tooManyPendingMessages": "Der KI-Revenue Manager kümmert sich gerade noch um deine anderen offenen Unterhaltungen. Bitte einen kurzen Moment gedulden und deine Nachricht dann erneut senden.",
            "unknownError": "Der KI-Revenue Manager kann aufgrund eines technischen Problems gerade nicht antworten. Bitte warte einen Moment und versuche es erneut. Sollte das Problem weiterhin auftreten, kontaktiere unser Support Team."
          },
          "titles": {
            "tooManyPendingMessages": "Zu viele Fragen in Bearbeitung",
            "unknownError": "Technisches Problem"
          }
        },
        "errorNote": {
          "error": "Die Anfrage konnte nicht verarbeitet werden.",
          "usageLimit": "Das Tageslimit wurde erreicht."
        },
        "exportMessage": "Unterhaltung herunterladen",
        "feedback": {
          "placeholderDown": "Was war ungenau oder wenig hilfreich?",
          "placeholderUp": "Was fandest du hilfreich? (optional)",
          "thumbsDown": "Daumen runter",
          "thumbsUp": "Daumen hoch",
          "title": "Dein Feedback"
        },
        "loadingMessages": "Nachrichten werden geladen...",
        "pending": {
          "pending": "Nachricht erhalten - der KI-Revenue Manager kümmert sich gleich darum",
          "phase": {
            "callingAgent": "Denkt nach...",
            "createMessage": "Wird initialisiert...",
            "processTool": "Daten werden analysiert...",
            "scheduleMessage": "Anfrage wird eingereiht...",
            "synthesizingResponse": "Anfrage wird abgeschlossen..."
          },
          "thinking": "Der KI-Revenue Manager arbeitet gerade an deiner Anfrage. Deine Daten werden analysiert...",
          "thinkingTakesLonger": "Die Analyse läuft noch - je mehr Daten vorliegen, desto länger dauert es, bis eine aussagekräftige Antwort vorliegt. Du kannst diesen Chat jederzeit verlassen, deine Antwort wartet, wenn du zurückkommst.",
          "tool": {
            "citeKnowledgeSource": "Wissensquellen werden erfasst...",
            "getAnalyseStats": "OTB-Performance Statistik wird aufgestellt...",
            "getCapacity": "Gesamte Hotelkapazität wird geprüft...",
            "getCategoryNames": "Kategorienamen werden aufgerufen...",
            "getClosedDays": "Schließtage werden berücksichtigt...",
            "getCurrentDateTime": "Ortszeit des Hotels wird geprüft...",
            "getCurrentWeather": "Aktuelles Wetter wird geprüft...",
            "getEvents": "Events werden abgerufen...",
            "getFilterValues": "Verfügbare Filteroptionen werden abgerufen...",
            "getForecasterCompany": "Forecast-Konfiguration wird geprüft...",
            "getFullMessageContent": "Vollständiger Nachrichtenverlauf wird gelesen...",
            "getFutureWeather": "Wettervorhersage wird geprüft...",
            "getLastSentRates": "Aktive Raten werden abgerufen..",
            "getMarketOccupancyComparisonStats": "Marktauslastung wird abgerufen...",
            "getMarketPickupComparisonStats": "Markt Pickup- und Stornierungstrends werden verglichen...",
            "getOccupancyForecast": "Auslastungsforecast wird geprüft...",
            "getPickupDevelopmentStats": "Pickup- und Stornierungstrends werden analysiert...",
            "getPickupStats": "Pickup- und Stornierungsstatistiken werden geprüft...",
            "getRatesToConfirm": "Ausstehende Ratenempfehlungen werden erfasst...",
            "getRecommendedRates": "Ratenempfehlungen werden geprüft...",
            "getRegionForecast": "Regionale Forecastdetails werden geprüft...",
            "getRevenueForecast": "Umsatzforecast wird geprüft...",
            "getRoomTypeNames": "Zimmertypen werden abgerufen...",
            "getShiftedDateOnSameDay": "Entsprechendes Datum wird berechnet...",
            "getShiftedDateOnSameWeekday": "Passender Wochentag wird ermittelt...",
            "getShiftedDatePeriod": "Datumsbereich wird angepasst...",
            "loadFullSkill": "Schritte für diese Aufgabe werden überprüft...",
            "resolveObservationDate": "Exaktes Betrachtungsdatum wird bestimmt..."
          }
        },
        "printSender": {
          "assistant": "KI-Revenue Manager",
          "system": "System"
        },
        "toggle": {
          "chart": "Diagramm",
          "hide": "{label} ausblenden",
          "show": "{label} anzeigen",
          "sources": "Verwandte Knowledge Base Artikel",
          "table": "Tabelle"
        }
      },
      "notEnoughCredits": {
        "inactiveTier": "Du nutzt RateBoard {tier}, also RateBoard ohne den KI-Revenue Manager. Wenn du ihn nutzen möchtest, {sendUsARequest} — wir finden gemeinsam die passende Lösung für dein Haus.",
        "inactiveTierTitle": "In deinem Lizenzplan ist kein KI-Guthaben enthalten",
        "moreCredits": "Am <b>{date}</b> steht dir bereits wieder Guthaben zur Verfügung, und du kannst genau dort weitermachen, wo du aufgehört hast.",
        "moreCreditsDaily": "Morgen steht dir bereits wieder Guthaben zur Verfügung, und du kannst genau dort weitermachen, wo du aufgehört hast.",
        "needMoreAiCredits": "Benötigst du mehr KI Guthaben?",
        "requestItNow": "Jetzt anfordern.",
        "sendUsARequest": "stell hier eine Anfrage",
        "title": "Du hast dein Nutzungslimit erreicht",
        "youveUsedAllYourCredits": "Du hast dein aktuelles Tageslimit erreicht"
      },
      "prompt": {
        "placeholder": "Gib hier deine Nachricht ein..."
      },
      "responseFormat": {
        "label": "Darstellen als"
      },
      "suggestions": {
        "mobileMenuLabel": "Häufig gestellte Fragen"
      }
    },
    "conversation": {
      "dateLabels": {
        "today": "Heute"
      },
      "editPlaceholder": "Neuen Titel der Unterhaltung eingeben",
      "loadingMore": "Einträge werden geladen...",
      "loadMore": "Mehr anzeigen"
    },
    "conversations": "Unterhaltungen",
    "creditUsage": {
      "adminOnlyInfo": "RateBoard-Modus · Kostenlose Nutzung",
      "availableCredits": "Verfügbares Guthaben",
      "dripBoost": {
        "daily": "Täglicher Boost",
        "weekly": "Wöchentlicher Boost"
      },
      "noCreditsInThisTier": "Kein KI-Guthaben in {tier}",
      "ofMonthlyCreditsUsed": "vom monatl. Guthaben genutzt",
      "requestAiManager": "KI-Revenue Manager anfragen",
      "requestItNow": "Jetzt anfordern.",
      "requestMoreCredits": "Benötigst du mehr KI Guthaben?",
      "requestUsage": "Benötigst du mehr KI Guthaben?",
      "tiers": {
        "custom": "Custom",
        "disabled": "Performance",
        "smart": "Smart"
      },
      "tooltip": {
        "availableCreditsDescription": "Jetzt sofort verfügbares Guthaben",
        "description": "Das verfügbare Guthaben hängt von deinem Tarif ab.",
        "dripDescription": {
          "daily": "Enthaltenes Guthaben, das täglich automatisch freigeschaltet wird.",
          "weekly": "Enthaltenes Guthaben, das wöchentlich automatisch freigeschaltet wird."
        },
        "title": "Erklärung der Nutzungslimits",
        "usedCreditsDescription": "In diesem Monat verbrauchtes Guthaben."
      },
      "usage": "Nutzung",
      "usedCredits": "Genutztes Guthaben"
    },
    "icon": {
      "label": "KI"
    },
    "modal": {
      "delete": {
        "message": "Löschen der Unterhaltung {title}? Diese Aktion kann nicht rückgängig gemacht werden.",
        "title": "Unterhaltung löschen"
      },
      "edit": {
        "title": "Titel der Unterhaltung bearbeiten"
      }
    },
    "untitled": "Ohne Titel"
  },
  "back": "Zurück",
  "benchmarking": {
    "cancellationChart": {
      "title": "Stornierung"
    },
    "chartHeader": {
      "inMonth": "im {month}",
      "legacyMonthPrefix": "in",
      "lessThanMarket": "{value}% weniger als der Markt",
      "moreThanMarket": "{value}% mehr als der Markt",
      "thisMonth": "dieser Monat",
      "tooltip": {
        "adr": {
          "description": "Dieses Diagramm zeigt den durchschnittlichen Tagespreis pro Monat für die letzten und kommenden 6 Monate und vergleicht ihn mit dem Marktdurchschnitt. Klicken Sie auf einen Monat, um Tagesdaten anzuzeigen."
        },
        "cancellation": {
          "description": "Dieses Diagramm zeigt die Stornierungen pro Monat für die letzten 12 Monate und vergleicht sie mit dem Marktdurchschnitt. Klicke auf einen Monat, um Tagesdaten anzuzeigen.",
          "title": "Stornierungen"
        },
        "occupancy": {
          "description": "Dieses Diagramm zeigt die Gesamtauslastung pro Monat für die letzten und kommenden 6 Monate und vergleicht sie mit dem Marktdurchschnitt. Klicken Sie auf einen Monat, um Tagesdaten anzuzeigen.",
          "title": "Auslastung"
        },
        "pickup": {
          "description": "Dieses Diagramm zeigt den Nettopickup (Pickup - Stornierungen) pro Monat für die letzten 12 Monate und vergleicht ihn mit dem Marktdurchschnitt. Klicke auf einen Monat, um Tagesdaten anzuzeigen.",
          "title": "Zimmernächte"
        },
        "pickupAndCancellation": {
          "description": "Dieses Diagramm zeigt den gesamten Pickup und die Stornierungen der letzten 30 Tage und vergleicht sie mit dem Marktdurchschnitt.",
          "title": "Pickup und Stornierungen"
        },
        "revpar": {
          "description": "Dieses Diagramm zeigt den durchschnittlichen RevPAR pro Monat für die letzten und kommenden 6 Monate und vergleicht ihn mit dem Marktdurchschnitt. Klicken Sie auf einen Monat, um Tagesdaten anzuzeigen."
        },
        "stayDays": {
          "description": "Dieses Diagramm zeigt die Verteilung des Pickups und der Stornierungen der letzten 30 Tage und vergleicht sie mit dem Marktdurchschnitt.",
          "title": "Aufenthaltstage"
        }
      }
    },
    "chartLabels": {
      "currentMonth": "Aktueller Monat",
      "market": "Markt",
      "yourCompany": "Mein Hotel"
    },
    "description": {
      "message1": "Stell dir deine Vergleichsgruppe über die Filter ",
      "message2": "Region, Sternekategorie, Hotelfokus",
      "message3": " (z. B. Wellness, Familien, …) und ",
      "message4": "Hoteltyp",
      "message5": " (Business und/oder Leisure) zusammen.",
      "message6": "Schau dabei nicht nur auf dein direktes geografisches Umfeld, sondern beziehe auch ähnliche Hoteltypen in anderen, vergleichbaren Regionen ein",
      "message7": " – so erhältst du aussagekräftigere und fairere Benchmarks für dein Hotel. Der Datenpool sollte dabei so groß wie möglich sein, bei gleichzeitig höchstmöglicher Homogenität.",
      "title1": "WICHTIGE INFORMATION!",
      "title2": "So wählst du deinen Markt:"
    },
    "dualTooltip": {
      "company": "Mein Hotel",
      "market": "Markt"
    },
    "infoTile": {
      "averageRateIndex": {
        "indicatorValue": "@:benchmarking.infoTile.rateGenerationIndex.indicatorValue",
        "title": "Durchschnittstarifindex",
        "tooltip": {
          "description": "Diese Registerkarte zeigt die Abweichung des ADR des Hotels im Vergleich zum Marktdurchschnitt. ARI = ADR des Hotels / Durchschnittlicher Markt-ADR.",
          "title": "Durchschnittstarifindex"
        },
        "underline": "@:benchmarking.infoTile.rateGenerationIndex.underline"
      },
      "lastMinutePickup": {
        "indicatorValue": {
          "decrease": "@:benchmarking.infoTile.pickup.indicatorValue.decrease",
          "increase": "@:benchmarking.infoTile.pickup.indicatorValue.increase"
        },
        "title": "Last minute Pickup",
        "underline": "Zimmernächte während der letzten 2 Wochen für die nächsten 2 Wochen gebucht"
      },
      "marketPenetrationIndex": {
        "indicatorValue": "@:benchmarking.infoTile.rateGenerationIndex.indicatorValue",
        "title": "Marktdurchdringungsindex",
        "tooltip": {
          "description": "Diese Karte zeigt die Abweichung der Belegung des Hotels im Vergleich zum Marktdurchschnitt. MPI = Belegungsrate des Hotels / Durchschnittliche Belegungsrate des Marktes * 100.",
          "title": "Marktdurchdringungsindex"
        },
        "underline": "@:benchmarking.infoTile.rateGenerationIndex.underline"
      },
      "pickup": {
        "indicatorValue": {
          "decrease": "{n}% weniger als der Markt",
          "increase": "{n}% mehr als der Markt"
        },
        "title": "Pickup",
        "underline": "Letzte 2 Wochen"
      },
      "rateGenerationIndex": {
        "indicatorValue": "{s} dieses Kalenderjahr",
        "title": "Preisgenerierungsindex",
        "tooltip": {
          "description": "Diese Karte zeigt die Abweichung des RevPAR des Hotels im Vergleich zum Marktdurchschnitt. RGI = RevPAR des Hotels / Durchschnittlicher RevPAR des Marktes.",
          "title": "Preisgenerierungsindex"
        },
        "underline": "dieser Kalendermonat"
      },
      "roomNights": "Zimmernächte",
      "trendingMonth": {
        "indicatorValue": "{d} für den Markt",
        "title": "Trendmonat",
        "underline": "{n} Zimmernächte in den letzten 2 Wochen gebucht"
      }
    },
    "last30Days": "Letzte 30 Tage",
    "marketFilter": {
      "applyFilters": "Filter anwenden",
      "comparedTo": {
        "comparedTo": "Vergleichen mit",
        "country": "Land des Hotels",
        "district": "Bezirk des Hotels",
        "group": {
          "country": "LAND",
          "district": "BEZIRK",
          "state": "BUNDESLAND",
          "zipCode": "PLZ"
        },
        "state": "Bundesland des Hotels",
        "zipCode": "PLZ des Hotels"
      },
      "hotelsFocus": "Fokus des Hotels",
      "hotelsType": "Hoteltyp",
      "stars": "Sterne",
      "tooLittleData": "Nicht genügend Marktdaten verfügbar. Versuchen Sie, Ihre Filterauswahl zu erweitern."
    },
    "newUi": {
      "advancedMode": "Erweiterter Modus",
      "advancedModeExplanation": "Nutze die Filter unten, um deine Vergleichsgruppe zu definieren. Der Datenpool sollte so groß wie möglich sein und gleichzeitig die größtmögliche Homogenität aufweisen. Beziehe beispielsweise auch ähnliche Hoteltypen aus anderen vergleichbaren Regionen ein.",
      "country": "Land",
      "district": "Bezirk",
      "headerTooltip": "Auf der Benchmarking-Seite werden zentrale KPIs mit dem für dich relevantesten Markt verglichen. Praktische Beispiele, Tipps und Unterstützung bei der Auswertung der Ergebnisse findest du in unserer {knowledgeBase}.",
      "help": "Benchmarking-Hilfe",
      "market": "Markt",
      "marketLoadError": "Die Markteinstellungen konnten nicht geladen werden.",
      "marketNotAvailableTooltip": "Der Markt für dein Hotel wurde im Vorfeld analysiert und optimal definiert.",
      "marketSaveError": "Die Markteinstellungen konnten nicht gespeichert werden.",
      "marketSaveSuccess": "Markteinstellungen erfolgreich gespeichert.",
      "marketSettings": "Marktdefinition",
      "marketTooltip": "Noch kein Markt definiert. Bitte wende dich an unser Support Team.",
      "newPreset": "Neu",
      "noFilters": "Kein Markt",
      "presets": "Presets",
      "readOnlyMarketExplanation": "Dieser Markt wird von RateBoard gepflegt und ist für Ihr Hotel schreibgeschützt.",
      "region": "Südtiroler\nTourismusregion",
      "retry": "Erneut versuchen",
      "saveChanges": "Änderungen speichern",
      "state": "Bundesland",
      "title": "Benchmarking",
      "tourismRegion": {
        "AHRNTAL": "Ahrntal",
        "ALTA_BADIA": "Dolomitenregion Alta Badia",
        "BOZEN": "Bozen und Umgebung",
        "BRIXEN": "Brixen und Umgebung",
        "DREI_ZINNEN": "Dolomitenregion Drei Zinnen",
        "EGGENTAL": "Dolomitenregion Eggental",
        "GROEDEN": "Dolomitenregion Gröden",
        "KRONPLATZ": "Dolomitenregion Kronplatz",
        "MERAN": "Meran und Umgebung",
        "NONE": "keine",
        "SEISER_ALM": "Dolomitenregion Seiser Alm",
        "STERZING": "Sterzing und Umgebung",
        "VILLNOESSTAL": "Dolomitenregion Villnösstal",
        "VINSCHGAU": "Vinschgau",
        "WEINSTRASSE": "Südtiroler Weinstraße"
      },
      "zipCode": "PLZ"
    },
    "occupancyChart": {
      "title": "Auslastung"
    },
    "pickupAndCancellationsChart": {
      "labels": {
        "cancellation": "Meine Stornierungen",
        "cancellationMarket": "Markt Stornierungen",
        "pickup": "Mein Pickup",
        "pickupMarket": "Markt PickUp"
      },
      "title": "PickUp und Stornierung"
    },
    "pickupChart": {
      "title": "Pickup"
    },
    "stayDays": {
      "title": "Aufenthaltstage für PickUp und Stornierung"
    },
    "upselling": {
      "activated": {
        "customize": "Nutzen Sie Filter wie Region, Hoteltyp oder Sterneklassifizierung um Ihr Hotel mit den für Sie relevanten Mitbewerbern zu vergleichen.",
        "stayTuned": "Bleiben Sie dran – das Feature wird am <b>01.07.2025</b> veröffentlicht. Sie erhalten Zugang zu wertvollen Einblicken in deinen Markt um wichtige Kennzahlen wie Auslastung, ADR, PickUp und mehr zu verfolgen, und Ihre Position am Markt zu analysieren.",
        "title": "Glückwunsch! Die Benchmarking-Funktion ist aktiviert"
      },
      "notActivated": {
        "alreadyRequested": "Das Feature wurde bereits bestellt. Bitte signiere den digitalen Vertrag, den wir dir per Mail zugesendet haben, im Anschluss wird das Benchmarking aktiviert.",
        "box": {
          "activate": "AKTIVIEREN UND TESTEN",
          "analyze": "Kennzahlen wie Auslastung, Pickup & ADR analysieren",
          "comparison": "Mit ähnlichen Hotels vergleichen",
          "customFilter": "Individuelle Filter: Region, Hoteltyp, Kategorie & Zielgruppe",
          "info": "Du erhältst den Vertrag per Mail, das Feature wird nach Zeichnung aktiviert.",
          "moreInformation": "Mehr Informationen",
          "questions": "Bei Fragen wende dich gerne telefonisch oder per E-Mail an <a href='mailto:support{'@'}rateboard.io'>support{'@'}rateboard.io</a>.",
          "resendContract": "Du findest die E-Mail bzw. den Vertrag nicht mehr? Einfach den Button klicken und den Vertrag nochmal erhalten:",
          "resendContractButton": "Vertrag erneut senden",
          "revenuePotential": "Umsatzpotenziale erkennen",
          "signContract": "Um die Aktivierung abzuschließen, unterschreibe bitte den Vertrag, den du per E-Mail erhalten hast. Erst nach erfolgreicher Unterzeichnung steht dir die Benchmarking-Funktion zur Verfügung.",
          "transparency": "Das Benchmarking Modul nutzt anonymisierte, aggregierte Daten vieler Betriebe - Rückschlüsse auf einzelne Hotels sind ausgeschlossen, auch nicht bezüglich deren Größe oder anderer spezifischer Informationen. Ein Opt-out ist jederzeit per E-Mail an <a href='mailto:support{'@'}rateboard.io'>support{'@'}rateboard.io</a> möglich; in diesem Fall steht das Modul nicht mehr zur Verfügung.",
          "withdrawal": "Nur {fee} - 7 Tage unverbindlich testen.",
          "withdrawalFee": "{fee}€/Monat"
        },
        "compareFigures": "Vergleichen Sie Kennzahlen wie Auslastung, Durchschnittsrate, Pickup und viele weitere für zukünftige und vergangene Zeiträume. Erstellen Sie individuelle Vergleiche mit frei wählbaren Filtern wie Land, Hoteltyp, Sternekategorie, Zielgruppe und mehr. Vergleichen Sie sich mit wem <b>Sie</b> möchten.",
        "identifyOpportunities": "Umsatzpotentiale für {company} identifizieren und Umsatz steigern - gezielt in nachfragestarken Zeiten."
      },
      "timer": {
        "days": "Tag | Tage",
        "untilRelease": "zum release"
      }
    }
  },
  "cancel": "Abbrechen",
  "clean": "Leeren",
  "close": "Schließen",
  "companyValues": {
    "focus": {
      "AIRPORT": "Flughafen",
      "BUSINESS_TRIPS": "Geschäftsreisen",
      "CITY_TRIPS": "Städtereisen",
      "CONFERENCES": "Konferenzen",
      "CUISINE": "Kulinarisches",
      "FAMILY": "Familie und Kinder",
      "MOUNTAIN": "Berge",
      "NATURE": "Natur",
      "WATER": "Wasser",
      "WELLNESS": "Wellness"
    },
    "segment": {
      "BUSINESS": "Business",
      "LEISURE": "Freizeit",
      "LEISURE_BUSINESS": "Freizeit & Business"
    },
    "stars": {
      "FIVE": "5 Sterne",
      "FIVE_SUPERIOR": "5 Sterne Superior",
      "FOUR": "4 Sterne",
      "FOUR_SUPERIOR": "4 Sterne Superior",
      "NOT_RATED": "Nicht bewertet",
      "ONE": "1 Stern",
      "THREE": "3 Sterne",
      "THREE_SUPERIOR": "3 Sterne Superior",
      "TWO": "2 Sterne"
    }
  },
  "compare": "Vergleichen",
  "connect": {
    "error": {
      "button": "Gehe zu RateBoard",
      "message": "Wir konnten Apaleo nicht mit RateBoard verbinden, kontaktieren Sie Ihren Onboarding Manager für weitere Informationen.",
      "title": "Etwas ist schief gelaufen!"
    },
    "pending": {
      "button": "Unterkunft verbinden",
      "message": "Bevor wir fortfahren, wählen Sie bitte die Unterkunft aus, die Sie verbinden möchten.",
      "title": "Fast fertig!"
    },
    "selectProperty": "Unterkunft wählen",
    "success": {
      "button": "Gehe zu RateBoard",
      "message": "Ihre Unterkunft wurde erfolgreich verbunden. Für weitere Informationen wenden Sie sich bitte an Ihren Onboarding Manager.",
      "title": "Sie sind verbunden!"
    }
  },
  "dashboard": {
    "chart": {
      "noData": "Keine Daten verfügbar",
      "week": "KW"
    },
    "createModal": {
      "cancel": "Abbrechen",
      "create": "Dashboard erstellen",
      "errors": {
        "duplicate": "Es gibt bereits ein Dashboard mit diesem Namen.",
        "empty": "Bitte einen Namen eingeben.",
        "length": "Maximal 40 Zeichen."
      },
      "fieldText": "Vergib deinem Dashboard einen eindeutigen Namen",
      "placeholder": "z. B. Wochenübersicht",
      "title": "Neues Dashboard"
    },
    "emptyState": "Du hast in dieser Ansicht noch keine Widgets hinzugefügt. Klicke auf \"WIDGET HINZUFÜGEN\" und wähle zwischen wichtigen Kennzahlen wie RevPAR, Auslastung oder Pickup, diejenigen aus, die dir helfen, deine Leistung im Blick zu behalten.",
    "header": {
      "addWidget": "WIDGET HINZUFÜGEN",
      "downloadPdf": "PDF herunterladen",
      "pmsDataFreshness": {
        "label": "PMS Daten aktualisiert: {timestamp}",
        "tooltip": {
          "contactSupport": "Support kontaktieren",
          "message": "Probleme bei der Datenübertragung."
        }
      },
      "widgetLimitReached": "Du hast das maximale Limit von {limit} Widgets erreicht. Lösche ein bestehendes Widget, um ein neues zu erstellen."
    },
    "switcher": {
      "copySuffix": "Kopie",
      "createNew": "Neu erstellen...",
      "dashboardLimitReached": "Du hast das maximale Limit von {limit} Dashboards erreicht. Lösche ein bestehendes Dashboard, um ein neues zu erstellen.",
      "deleteDashboardModal": {
        "message": "Du kannst diese Aktion später nicht mehr rückgängig machen. Das Entfernen wirkt sich nur auf dein Konto aus.",
        "title": "Bist du sicher, dass du das Dashboard {name} löschen möchtest?"
      },
      "duplicateDashboard": "Dashboard Duplizieren",
      "duplicateModal": {
        "label": "Dashboard-Name"
      },
      "lastDashboardCannotBeDeleted": "Dieses Dashboard kann nicht gelöscht werden, da mindestens ein Dashboard vorhanden sein muss.",
      "nameValidation": "Geben Sie einen eindeutigen Dashboard-Namen ein.",
      "newDashboardName": "Unbenanntes Dashboard",
      "noDashboardSelected": "Kein Dashboard ausgewählt"
    },
    "templateManagement": {
      "archive": "Archivieren",
      "archived": "Archiviert",
      "archiveMessage": "Die Vorlage steht Benutzern nicht mehr zur Verfügung. Bereits damit erstellte Dashboards sind davon nicht betroffen. Sie können weiterhin darauf zugreifen und sie später erneut veröffentlichen.",
      "archiveTitle": "Möchten Sie die Vorlage {name} wirklich archivieren?",
      "chooseFile": "Datei auswählen",
      "copySuffix": "Kopie",
      "create": "Vorlage erstellen",
      "createAction": "Vorlage erstellen",
      "deleteMessage": "Sie können diese Aktion später nicht mehr rückgängig machen. Dadurch wird die Vorlage für alle SUPER-ADMINS gelöscht.",
      "deleteTitle": "Möchten Sie die Vorlage {name} wirklich löschen?",
      "draft": "Entwurf",
      "duplicate": "Vorlage duplizieren",
      "duplicateAction": "Vorlage duplizieren",
      "edit": "Bearbeiten",
      "error": "Die Vorlage konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
      "fields": "Vorlagenfelder",
      "isOnboardingTemplate": "Onboarding-Vorlage",
      "loading": "Vorlagen werden geladen...",
      "manage": "Vorlagen verwalten",
      "nameDe": "Deutscher Name",
      "nameEn": "Englischer Name",
      "nameIt": "Italienischer Name",
      "newTemplate": "Neue Vorlage",
      "noThumbnail": "Keine Datei ausgewählt",
      "onboardingDefault": "Standard für Onboarding",
      "placeholderNames": {
        "de": "Neue Vorlage",
        "en": "New Template",
        "it": "Nuovo modello"
      },
      "publish": "Veröffentlichen",
      "publishAction": "Vorlage veröffentlichen",
      "published": "Veröffentlicht",
      "publishMessage": "Die Vorlage wird für alle Benutzer sichtbar sein.",
      "publishTitle": "Möchten Sie die Vorlage {name} wirklich veröffentlichen?",
      "settings": "Einstellungen",
      "thumbnail": "Vorschaubild",
      "thumbnailAvailable": "Vorschaubild vorhanden",
      "thumbnailError": "Das Vorschaubild konnte nicht hochgeladen werden. Bitte versuchen Sie es erneut.",
      "thumbnailRequired": "Zum Veröffentlichen einer Vorlage ist ein Vorschaubild erforderlich.",
      "title": "Vorlagen verwalten",
      "unpublish": "Veröffentlichung aufheben",
      "validation": "Geben Sie eindeutige Namen auf Deutsch, Englisch und Italienisch ein.",
      "view": "Anzeigen",
      "viewThumbnail": "Vorschaubild anzeigen"
    },
    "templatesModal": {
      "createNew": "Benutzerdefiniertes Dashboard",
      "subtitle": "Wähle eine Option aus, um mit der Erstellung eines neuen Dashboards zu beginnen.",
      "title": "Vorlagen"
    },
    "widgetLibrary": {
      "add": "Hinzufügen",
      "header": {
        "cancel": "Abbrechen",
        "selectWidgets": "Wähle hier Widgets aus, um sie auf deinem Dashboard zu platzieren"
      },
      "preview": {
        "notifications": {
          "bookings20Lower": "Buchungen 20 % niedriger",
          "revenue15Higher": "Umsatz 15 % höher"
        },
        "weather": {
          "city": "Innsbruck"
        }
      },
      "search": {
        "placeholder": "Widgets durchsuchen..."
      },
      "title": "Widget-Bibliothek",
      "widgetTypes": {
        "adr": "ADR",
        "all": "Alle Widgets",
        "budgetGoal": "Budgetziel",
        "cancellation": {
          "revenue": "Umsatz",
          "roomNights": "Zimmernächte",
          "title": "Stornierung"
        },
        "market": "Markt",
        "notification": "Benachrichtigungen",
        "occupancy": "Auslastung",
        "pickup": {
          "distribution": "Pickup Verteilung",
          "revenue": "Brutto Pickup Umsatz",
          "revenueTotal": "NETTO PICKUP UMSATZ",
          "roomNights": "Brutto Pickup",
          "roomNightsTotal": "NETTO PICKUP",
          "title": "Pickup"
        },
        "rateAdjustment": "Ratenempfehlungen",
        "revenue": "Umsatz",
        "review": "Bewertung",
        "revPar": "RevPAR",
        "today": "Heute",
        "weather": "Wetter"
      }
    },
    "widgets": {
      "adr": {
        "title": "ADR",
        "tooltipKpi": "ADR"
      },
      "budgetGoal": {
        "differenceToGoal": "Abweichung vom Budgetziel",
        "goalOccupancy": "Auslastung Ziel",
        "goalRevenue": "Umsatz Ziel",
        "otbOccupancy": "Auslastung OTB",
        "otbRevenue": "Umsatz OTB",
        "title": "Budget",
        "tooltipKpi": "OTB"
      },
      "cancellationRevenue": {
        "legendKpi": "Stornierter Umsatz",
        "title": "Stornierter Umsatz",
        "tooltipKpi": "Stornierter Umsatz"
      },
      "cancellationRoomNights": {
        "cancellations": "Stornierungen",
        "title": "Stornierte Zimmernächte",
        "tooltipKpi": "Stornierte Zimmernächte"
      },
      "market": {
        "companyAverage": "Mein Hotel",
        "differenceToMarket": "Differenz zum Markt",
        "infoTooltip": "Die Marktwerte sind echte PMS-Daten der Hotels aus Deinem geografischen Benchmarking-Markt. Der regionale Forecast zeigt die Nachfrageentwicklung in Deiner Region.",
        "infoTooltipHeader": "JETZT NEU! Deine Auslastung im Vergleich zum Markt.",
        "marketAverage": "Markt",
        "occupancy": "Auslastung",
        "occupancyThisMonth": "Auslastung in diesem Monat",
        "regionalForecast": "Regionaler Forecast",
        "title": "Markt"
      },
      "notification": {
        "activated": "Aktiviert am {date}",
        "affectedDays": "{count} Tage betroffen von {from} bis {to}",
        "noData": "Du hast momentan keine aktiven Benachrichtigungen. Gehe zur Seite Benachrichtigungen, um diese zu verwalten.",
        "title": "Benachrichtigungen"
      },
      "occupancy": {
        "forecastTooltip": "Forecast",
        "title": "Auslastung",
        "tooltipKpi": "Auslastung"
      },
      "pickupDistribution": {
        "cancelledRoomnights": "Stornierte Zimmernächte",
        "confirmedRoomnights": "Bestätigte Zimmernächte",
        "timeRange": {
          "custom": "vom {from} - {to}",
          "lastDays": "der letzten {count} Tage",
          "lastMonths": "der letzten {count} Monate",
          "today": "vom heutigen Tag",
          "yesterday": "von gestern"
        },
        "title": "Pickup Verteilung"
      },
      "pickupRevenue": {
        "title": "Brutto Pickup Umsatz",
        "tooltipKpi": "Brutto Pickup Umsatz"
      },
      "pickupRevenueTotal": {
        "cancelledLabel": "Umsatz Stornierungen",
        "netLegendLabel": "Netto {year}",
        "netValueLabel": "Umsatz PickUp",
        "pickupLabel": "Brutto Pickup Umsatz",
        "title": "NETTO PICKUP UMSATZ",
        "tooltipKpi": "Umsatz"
      },
      "pickupRoomNights": {
        "title": "Brutto Pickup",
        "tooltipKpi": "Brutto Pickup"
      },
      "pickupRoomNightsTotal": {
        "cancelledLabel": "Stornierungen",
        "netLabel": "Brutto Pickup",
        "netLegendLabel": "Netto {year}",
        "netValueLabel": "Netto Zimmernächte",
        "pickupLabel": "Brutto Pickup",
        "title": "NETTO PICKUP",
        "tooltipKpi": "Zimmernächte"
      },
      "rateAdjustment": {
        "majorRateAdjustments": "Signifikante Anpassungen",
        "noData": "Es gibt keine Tarifempfehlungen für die nächsten 12 Monate. Prüfen Sie Ihre Einstellungen, um sicherzustellen, dass alles korrekt eingerichtet ist.",
        "rateAdjustments": "Alle Anpassungen",
        "subtitle": "Für die nächsten 12 Monate",
        "title": "Ratenempfehlungen"
      },
      "rateAdjustmentsCount": {
        "subtitle": "abgeschlossen in den letzten 7 Tagen",
        "title": "Preisanpassungen"
      },
      "reference": "Referenz",
      "revenue": {
        "forecastTooltip": "Forecast",
        "title": "Umsatz",
        "tooltipKpi": "Umsatz"
      },
      "reviews": {
        "average": "Durchschnitt",
        "overallDistribution": "Gesamtverteilung",
        "reviewsCount": "{count} Bewertungen in den letzten 6 Monaten",
        "title": "Bewertungen"
      },
      "revPar": {
        "title": "RevPAR",
        "tooltipKpi": "RevPAR"
      },
      "settings": {
        "cancel": "Abbrechen",
        "category": {
          "label": "Filtern nach"
        },
        "comparison": {
          "groups": {
            "final2YearsAgo": "FINAL 2 JAHRE VORHER",
            "finalLastYear": "FINAL VORJAHR",
            "sameTime2YearsAgo": "SELBE ZEIT 2 JAHRE VORHER",
            "sameTimeLastYear": "SELBE ZEIT VORJAHR"
          },
          "label": "Verglichen mit",
          "options": {
            "custom": "Benutzerdefiniert",
            "lastYear": "Letztes Jahr",
            "none": "nicht gewählt",
            "sameDate2YearsAgo": "Gleiches Datum YTD 2J",
            "sameDate2YearsAgoFinal": "Gleiches Datum final 2J",
            "sameDateLastYear": "Gleiches Datum YTD 1J",
            "sameDateLastYearFinal": "Gleiches Datum final 1J",
            "sameWeekday2YearsAgo": "Gleicher Wochentag YTD 2J",
            "sameWeekday2YearsAgoFinal": "Gleicher Wochentag final 2J",
            "sameWeekdayLastYear": "Gleicher Wochentag YTD 1J",
            "sameWeekdayLastYearFinal": "Gleicher Wochentag final 1J"
          }
        },
        "done": "Speichern",
        "kpi": {
          "label": "KPI",
          "options": {
            "occupancy": "Auslastung",
            "revenue": "Umsatz"
          }
        },
        "majorDiff": {
          "label": "Signifikanz",
          "tooltip": "Im Diagramm werden Ratenempfehlungen hervorgehoben, die x % über bzw. unter der aktuellen Rate liegen.",
          "tooltipTitle": "Signifikanz"
        },
        "rateType": {
          "label": "Ratentyp",
          "options": {
            "highest": "Höchste",
            "lowest": "Am niedrigsten"
          }
        },
        "remove": "Löschen",
        "size": {
          "label": "Größe",
          "options": {
            "large": "Groß",
            "medium": "Mittel",
            "small": "Klein"
          }
        },
        "timeRange": {
          "label": "Zeitraum",
          "options": {
            "currentMonth": "Aktueller Monat",
            "currentQuarter": "Aktuelles Quartal",
            "currentWeek": "Aktuelle Woche",
            "currentYear": "Aktuelles Jahr",
            "custom": "Benutzerdefiniert",
            "last12Months": "Letzte 12 Monate",
            "last14Days": "Letzte 14 Tage",
            "last30Days": "Letzte 30 Tage",
            "last3Days": "Letzte 3 Tage",
            "last6Months": "Letzte 6 Monate",
            "last7Days": "Letzte 7 Tage",
            "last90Days": "Letzte 90 Tage",
            "next12Months": "Nächste 12 Monate",
            "next14Days": "Nächste 14 Tage",
            "next30Days": "Nächste 30 Tage",
            "next6Months": "Nächste 6 Monate",
            "next7Days": "Nächste 7 Tage",
            "next90Days": "Nächste 90 Tage",
            "today": "Heute",
            "yesterday": "Gestern"
          },
          "optionsSince": {
            "last12Months": "Seit 12 Monaten",
            "last14Days": "Seit 14 Tagen",
            "last30Days": "Seit 30 Tagen",
            "last6Months": "Seit 6 Monaten",
            "last7Days": "Seit 7 Tagen",
            "last90Days": "Seit 90 Tagen"
          }
        },
        "title": "Widget-Einstellungen",
        "validation": {
          "dateRangeRequired": "Datumsbereich erforderlich"
        }
      },
      "timeRangeLabels": {
        "comparisonSubtitles": {
          "lastYear": "zum Vorjahr",
          "sameDate2YearsAgo": "zu vor 2 Jahren",
          "sameDateLastYear": "zum Vorjahr",
          "sameWeekday2YearsAgo": "zu vor 2 Jahren",
          "sameWeekdayLastYear": "zum Vorjahr",
          "twoYearsAgo": "zu vor 2 Jahren"
        },
        "differenceTo": "Differenz",
        "inThe": "In den",
        "subtitles": {
          "currentMonth": "Im aktuellen Monat",
          "currentQuarter": "Im aktuellen Quartal",
          "currentWeek": "In der aktuellen Kalenderwoche",
          "currentYear": "Im aktuellen Jahr",
          "last12Months": "letzten 12 Monaten",
          "last14Days": "letzten 14 Tagen",
          "last30Days": "letzten 30 Tagen",
          "last6Months": "letzten 6 Monaten",
          "last7Days": "letzten 7 Tagen",
          "last90Days": "letzten 90 Tagen",
          "next12Months": "nächsten 12 Monaten",
          "next14Days": "nächsten 14 Tagen",
          "next30Days": "nächsten 30 Tagen",
          "next6Months": "nächsten 6 Monaten",
          "next7Days": "nächsten 7 Tagen",
          "next90Days": "nächsten 90 Tagen"
        },
        "tooltipSubtitles": {
          "sameDate2YearsAgo": "gleiches Datum (zur selben Zeit YTD 2J)",
          "sameDate2YearsAgoFinal": "gleiches Datum (finale Werte)",
          "sameDateLastYear": "gleiches Datum (zur selben Zeit YTD 1J)",
          "sameDateLastYearFinal": "gleiches Datum (finale Werte)",
          "sameWeekday2YearsAgo": "gleicher Wochentag (zur selben Zeit YTD 2J)",
          "sameWeekday2YearsAgoFinal": "gleicher Wochentag (finale Werte)",
          "sameWeekdayLastYear": "gleicher Wochentag (zur selben Zeit YTD 1J)",
          "sameWeekdayLastYearFinal": "gleicher Wochentag (finale Werte)"
        }
      },
      "today": {
        "adr": "ADR",
        "cancellation": "Stornierungen",
        "cancellationRevenue": "Stornierungsumsatz",
        "netPickup": "Netto-Pickup",
        "netPickupRevenue": "Netto-Pickup-Umsatz",
        "occupancy": "Auslastung",
        "revenue": "Umsatz",
        "revpar": "RevPAR",
        "subtitleToday": "Heute",
        "title": "Heute"
      },
      "weather": {
        "highLow": "H: {high}° T: {low}°",
        "noData": "Keine Wetterdaten verfügbar",
        "title": "Wetter",
        "wind": "Wind: {speed}km/h"
      }
    }
  },
  "dataPrivacyAgreement": {
    "beforeAccessSign": "Bevor Sie auf die Hotelseite zugreifen können, müssen Sie die Datenverarbeitungsvereinbarung (DPA) unterzeichnen, um die Einhaltung der Datenschutzbestimmungen zu gewährleisten.",
    "canStillAccess": "Sie können weiterhin auf andere Hotels zugreifen, welchen Sie zugewiesen sind.",
    "notAccessUntilSigned": "Sie können leider nicht auf dieses Hotel zugreifen, bis die Datenverarbeitungsvereinbarung (DPA) von einem der ADMIN-Benutzer des Hotels unterzeichnet wurde.",
    "readAndSign": "LESEN UND DPA UNTERSCHREIBEN"
  },
  "dataTable": {
    "empty": "Keine Einträge gefunden.",
    "loading": "Daten werden geladen...",
    "of": "von",
    "page": "Seite",
    "perPage": "pro Seite",
    "to": "bis"
  },
  "deactivated": "Deaktiviert",
  "delete": "Löschen",
  "dropdownSelect": {
    "all": "Alle",
    "empty": "Leer",
    "none": "Kein",
    "noneChosen": "Nicht gewählt",
    "nSelected": "{number} ausgewählt"
  },
  "error": "Fehler",
  "fileUploader": {
    "choose": "Datei auswählen",
    "dragAndDrop": "Ziehen Sie Ihre Datei hierher oder klicken Sie, um zu durchsuchen",
    "invalidFile": "Die Datei ist leer oder im falschen Format. Bitte laden Sie eine gültige Datei hoch.",
    "remove": "Datei entfernen"
  },
  "filterPreset": {
    "modal": {
      "message": "Geben Sie einen einzigartigen Namen ein, um Ihre Voreinstellung für die zukünftige Verwendung zu speichern",
      "title": "Neuen Filter als Voreinstellung speichern"
    },
    "newPreset": "Neue Voreinstellung",
    "preset": "Voreinstellung",
    "presets": "Voreinstellungen"
  },
  "footer": {
    "contact": {
      "title": "Kontaktiere uns"
    },
    "support": {
      "times1": "Montag - Donnerstag, 8:00 - 17:00 CET",
      "times2": "Freitag, 08:00 - 14:00 CET",
      "title": "Supportzeiten"
    }
  },
  "header": {
    "knowledgeBase": "Knowledge Base",
    "menu": {
      "administration": {
        "assistant": "Assistent",
        "connectivityStats": "Connectivity stats",
        "customerSuccessManagement": "CSM",
        "forecastControl": "Forecast Control",
        "hotelAdministration": "Administration",
        "inboundData": "Eingehende Daten",
        "monitoring": "Monitoring",
        "outboundLogs": "Outbound Logs",
        "rateEnginePOC": "RateEngine POC",
        "regionForecastControl": "Region Forecast Control",
        "reportsOverview": "Report Übersicht",
        "reservationOverview": "Res. Übersicht",
        "schedulers": "Scheduler",
        "users": "Users"
      },
      "analyse": {
        "analyse": "Analyse",
        "budget": "Budget",
        "comparison": "@:analyse.comparison.title",
        "competitors": "Mitbewerber",
        "hotel": "@:analyse.hotel.title",
        "marketTrend": "Markttrends",
        "pickUp": "PickUp",
        "reputation": "Bewertungen"
      },
      "settings": {
        "budgetConfiguration": "Budget Einstellungen",
        "competitors": "Mitbewerber",
        "events": "Events",
        "interfaceConfiguration": "Schnittstellen Konfiguration",
        "inventory": "Inventar Verwaltung",
        "notifications": "Benachrichtigungen",
        "priceLevels": "Preisstufen-Kalender",
        "ratePlans": "Rate Plans",
        "rateRounding": "Preisrundung",
        "rateRules": "Preisregeln",
        "restrictions": "Restriktionen",
        "roomPricingConfiguration": "Preiskonfiguration",
        "segmentation": "Segmentierung",
        "statusConfiguration": "Status Einstellungen"
      },
      "title": {
        "activityLog": "Aktivitätsprotokoll",
        "administration": "Administration",
        "analyse": "Analyse",
        "dashboard": "Dashboard",
        "manage": "Manage",
        "settings": "Settings"
      }
    },
    "releaseNotes": "Release Notes"
  },
  "hotelSelection": {
    "message": "Wählen Sie eine Standardunterkunft aus, das angezeigt wird, wenn Sie sich bei RateBoard anmelden. Sie können dies später in den Profileinstellungsseite ändern.",
    "title": "Standardunterkunft auswählen"
  },
  "invitationConfirmation": {
    "allDone": "Alles erledigt!",
    "confirmInvitation": "Bestätigen Sie Ihre Angaben, um fortzufahren und Ihr RateBoard-Konto zu erstellen.",
    "createPassword": "Passwort erstellen",
    "createPasswordSoLogin": "Erstellen Sie ein Passwort, um sich in Ihrem RateBoard-Konto anzumelden.",
    "fields": {
      "acceptTerms": "Allgemeine Geschäftsbedingungen und Datenschutzbestimmungen akzeptieren",
      "confirmPassword": "Passwort bestätigen",
      "password": "Passwort"
    },
    "goToLogin": "ZUR LOGIN-SEITE GEHEN",
    "hotelAssigned": "Hotel {company} wurde erfolgreich Ihrem RateBoard-Konto zugewiesen. Sie können sich bereits anmelden und auf das Hotel zugreifen.",
    "invitationNotFound": {
      "message": "Bitte wenden Sie sich an die Person, die die Einladung gesendet hat, oder an unser Team, wenn das Problem weiterhin besteht.",
      "title": "Leider wurde keine Einladung gefunden."
    },
    "inviteAlreadyAccepted": "Die Einladung wurde bereits angenommen.",
    "invitedToJoin": "Sie wurden eingeladen, dem Hotel {company} beizutreten",
    "inviteExpired": "Entschuldigung, diese Einladung ist abgelaufen",
    "somethingWrongHappened": "Entschuldigung, es ist etwas schief gelaufen",
    "submitLabel": "BENUTZER ERSTELLEN",
    "unableToCreate": "Es scheint, dass wir Ihr Konto nicht erstellen konnten. Sie können es über denselben Link erneut versuchen.",
    "unfortunatelyInviteExpired": "Bitte wenden Sie sich an unser Support Team unter <a href='mailto:support{'@'}rateboard.io'>support{'@'}rateboard.io</a>, um einen neuen Link anzufordern.",
    "validation": {
      "confirmPassword": "Passwörter stimmen nicht überein",
      "email": "E-Mail stimmt nicht mit Einladung überein",
      "password": "Das Passwort muss mindestens 8 Zeichen lang sein"
    }
  },
  "login": {
    "account": "Sie haben keinen Account?",
    "contactus": "Kontaktieren Sie uns",
    "error": {
      "blocked": "Zu viele Anmeldeversuche. Ihr Zugang ist für 10 Minuten gesperrt!",
      "blockedNew": "Aus Sicherheitsgründen ist Ihr Konto aufgrund mehrfacher falscher Anmeldeversuche für 10 Minuten gesperrt.",
      "browser": "Ihr Browser wird nicht unterstützt",
      "credentials": "Login fehlgeschlagen",
      "credentialsNew": "Anmeldung leider nicht möglich. Bitte überprüfe, ob du den richtigen Benutzernamen und das richtige Passwort eingegeben hast.",
      "noActiveCompany": "Diesem Benutzer ist kein aktives Hotel zugewiesen."
    },
    "forgotPassword": {
      "email": "Bitte überprüfen Sie Ihre E-Mail für weitere Anweisungen!",
      "emailNew": "Überprüfen Sie Ihren Posteingang – wir haben Ihnen einen Link zum Zurücksetzen Ihres Passworts gesendet.",
      "forgot": "Passwort vergessen",
      "reset": {
        "button": "Zurücksetzen",
        "buttonNew": "E-Mail senden",
        "description": "Wir senden einen Link zum Zurücksetzen des Passworts an Ihre E-Mail-Adresse.",
        "link": "Passwort zurücksetzen"
      }
    },
    "password": "Passwort",
    "twoFactorAuthentication": {
      "authenticationDevice": "Sie können Ihr Gerät nicht zur Authentifizierung nutzen?",
      "otpInputField": "6-stelliger Code",
      "title": "Zwei-Faktor-Authentifizierung"
    },
    "username": "Benutzername",
    "usernameOrEmail": "Benutzername oder E-Mail-Adresse"
  },
  "logout": "Logout",
  "maintenanceMode": {
    "message": "<b>RateBoard befindet sich derzeit im Wartungsmodus, aber keine Sorge —</b> es wird bald wieder funktionieren. Wir nehmen einige Verbesserungen vor, um Ihnen ein besseres Erlebnis zu bieten. Vielen Dank für Ihre Geduld!",
    "title": "Wir sind bald zurück!"
  },
  "manage": {
    "autopilot": {
      "description": "Dieses Feature veröffentlicht empfohlene Raten automatisch.",
      "dialog": {
        "applyAll": "Diese Einstellung für alle Zimmerkategorien übernehmen.",
        "difference": "diff.",
        "from": "von",
        "fromTo1": "Nur Raten für",
        "fromTo2": "Tage vor Anreise veröffentlichen.",
        "fromToEmpty": "Von und Bis Tage vor Anreise sind Pflichtelder.",
        "fromToNegative": "Von und Bis Tage vor Anreise kann nicht negativ sein.",
        "fromToOverlap": "Von muss kleiner als Bis sein.",
        "fromToRange": "Von und Bis Tage vor Anreise müssen zwischen 0 und 540 liegen.",
        "lowerLimitLabel": "Unteres Limit",
        "rateOffset1": "Akzeptiere",
        "rateOffset2": "ÜBER der",
        "rateOffset3": "UNTER der",
        "rateOffsetActiveRate": "aktiven Rate",
        "rateOffsetBaseRate": "Basis Rate",
        "rateOffsetConnector": "die",
        "rateOffsetConnectorNegativeAll": "die",
        "rateOffsetConnectorNegativeLimit": "die bis",
        "rateOffsetConnectorPositiveAll": "die",
        "rateOffsetConnectorPositiveLimit": "die bis",
        "rateOffsetEmpty": "Die Differenz darf nicht leer sein.",
        "rateOffsetEnd": "liegen.",
        "rateOffsetKnowledgebaseLinkLabel": "Knowledgebase",
        "rateOffsetKnowledgebaseText": "Eine ausführliche Dokumentation zu den verfügbaren Einstellungen ist hier zu finden:",
        "rateOffsetLimitNote": "Wenn Ratenempfehlungen die eingestellten Grenzen überschreiten oder unterschreiten, wird der Autopilot die Rate genau am definierten Grenzwert veröffentlichen.",
        "rateOffsetModeAllRates": "Alle Raten",
        "rateOffsetModeNoRates": "keine Raten",
        "rateOffsetModeRatesUpTo": "nur jene Raten",
        "rateOffsetNegative": "Die Differenz kann nicht negativ sein.",
        "saveChanges": "Änderungen speichern",
        "to": "bis",
        "upperLimitLabel": "Oberes Limit"
      },
      "disabledTooltip": "Autopilot deaktiviert",
      "enabledTooltip": "Autopilot aktiv",
      "title": "Autopilot"
    },
    "calendar": {
      "day": {
        "autopilot": {
          "active": "Autopilot aktiv",
          "fixedRate": "Rate fixiert"
        },
        "closed": "Geschlossen",
        "event": {
          "current": "Event dieses Jahr",
          "past": "Event Vorjahr"
        },
        "modifications": {
          "algorithm": "Algorithmus",
          "baseRate": "Basisrate",
          "primaryRecommendation": "Primäre Empfehlung",
          "rules": "Regeln"
        },
        "rate": {
          "baseRateTooltip": "Basisrate plus Preisregeln (kein Algorithmus)"
        },
        "rateSync": {
          "lastRate": "Letzte erfolgreich gesendete Rate"
        },
        "restriction": {
          "cta": "Geschlossen für Anreisen (CTA)",
          "ctd": "Geschlossen für Abreisen (CTD)",
          "minLos": "Mindestaufenthaltsdauer"
        }
      }
    },
    "changeLog": {
      "applyPublish": "Verbindlich freigeben",
      "discardChanges": "Änderungen verwerfen",
      "noChangesYet": "Sie haben noch keine Änderungen vorgenommen. Wenn Sie Preise im Kalender anpassen sehen Sie hier eine Zusammenfassung der Änderungen.",
      "responseCode": {
        "invalidRatePlanRoomCategories": "Einige Zimmerkategorien haben keinen Wert in der Rate Plan Hierarchie. Bitte unter Settings/Rate Plans ändern.",
        "invalidRoomMapping": "Einige Zimmertypen verfügen nicht über eine gültige Channel Manager room type ID.",
        "invalidRoomPrices": "Die Preiskonfiguration ist ungültig.",
        "noApiUrl": "Schnittstellen URL nicht gesetzt.",
        "noHotelCode": "Hotelcode fehlt.",
        "noPms": "PMS Einstellungen fehlen.",
        "noRate": "Für mindestens einen gewählten Tag sind keine Raten hinterlegt. Für das Senden sind diese notwendig.",
        "noRatePlan": "Kein Rateplan hinterlegt.",
        "normalGuestCountTooLarge": "Standardbelegung zu hoch. Bitte in Preiskonfiguration anpassen.",
        "noRoomsMapped": "Zimmertyp-Mapping für Schnittstelle fehlt.",
        "notMappedRooms": "Sie verwenden Zimmertypen welche in keinem ausgehenden Interface verwendet werden. Daher können keine Raten oder Restriktionen geschickt werden. Bitte ändern Sie das Mapping oder schließen Sie den Zimmertyp aus.",
        "publishDisabled": "Das Senden von Änderungen ist für alle Interfaces deaktiviert.",
        "ratesNotSaved": "Raten konnten nicht gespeichert werden.",
        "restrictionsNotSaved": "Restriktionen konnten nicht gespeichert werden.",
        "roomTypePriceInvalid": "Preiskonfiguration für Zimmertyp {roomTypeName} ist ungültig.",
        "unexpected": "Daten konnten nicht gesendet werden, wurden aber gespeichert.",
        "unknownError": "Interner Server Fehler."
      },
      "responseMessage": {
        "noRateLevel": "Kein Preislevel gesetzt.",
        "rateOutOfBounds": "Rate außerhalb der Preisspanne."
      },
      "reviewedHint": "Haben Sie alle gewünschten Änderungen vorgenommen und genau überprüft?",
      "table": {
        "category": "Kategorie",
        "closed": "Geschlossen",
        "cta": "CTA",
        "ctd": "CTD",
        "details": "Details",
        "insteadOf": "statt",
        "maxLos": "MaxLOS",
        "minLos": "MinLOS",
        "minLosOutOfRange": "Nicht alle deiner PMS unterstützen MinLOS = {count}. Sie werden in Ihren PMS nicht überall den selben Wert sehen!",
        "open": "Offen",
        "rooms": "Zimmer",
        "settingsRemoved": "Einstellungen werden entfernt",
        "what": "Was",
        "when": "Wann"
      },
      "title": "Protokoll Ihrer Änderungen",
      "types": {
        "rate": "Rate geändert",
        "ratePlans": "Rate plans geändert",
        "rateSettings": "Rateneinstellungen geändert",
        "restrictions": "Restriktionen geändert"
      },
      "warning": "Warnung",
      "warningMonthChange": "Wenn Sie Monat wechseln verlieren Sie ungespeicherte Änderungen. Sind Sie sicher, dass Sie fortfahren möchten?",
      "warningRefreshPage": "Wenn du fortfährst, gehen deine Änderungen verloren! Möchtest du trotzdem fortfahren?"
    },
    "editRates": "Preise editieren",
    "nextMonth": "Nächster Monat",
    "noDaysSelected": "Sie haben momentan keine Tage ausgewählt. Markieren Sie einen oder mehrere Tage im Kalender um eine detailliertere Ansicht zu erhalten und Preise anzupassen.",
    "noRoomCategoryMapped": "Keine Zimmerkategorien zugewiesen",
    "previousMonth": "Vorheriger Monat",
    "recommendationStatus": {
      "completed": "Berechnung der Ratenempfehlung abgeschlossen.",
      "finished": "Berechnung der Ratenempfehlung läuft. Dies kann einige Minuten dauern.",
      "refreshRequired": "Aktualisiere die Seite, um die Ratenempfehlungen zu aktualisieren",
      "title": "Status Ratenempfehlung "
    },
    "resync": {
      "button": "Daten resynchronisieren",
      "disabledHint": "Die letzte Resynchronisierung ist noch aktiv. Bitte versuchen Sie es später erneut.",
      "errorLog": {
        "downloadAll": "Alle downloaden",
        "outOf": "{count1} von {count2} Fehler",
        "title": "Fehlerprotokoll",
        "types": {
          "base": "Allgemein",
          "channel": "Channel",
          "rate": "Rate"
        }
      },
      "message": "Senden Sie akzeptierte Raten und aktuelle Restriktionen für die nächsten 24 Monate an alle angeschlossenen PMS und CM.",
      "modal": {
        "hint1": {
          "part1": "Die erneute Synchronisierung beinhaltet Raten für die nächsten 24 Monate, neue Restriktionen, neue Einstellungen in der Preiskonfiguration, neue Einstellungen in den Rate Plans und neue Einstellungen in den Preisstufen (Ableitung von Nicht-Primärtypen). Die Resynchronisierung ",
          "part2": "akzeptiert keine ",
          "part3": "neuen Ratenempfehlungen! ",
          "part4": "Wichtig! ",
          "part5": "Wenn Sie Raten im Kalender manuell angepasst haben, werden diese nicht überschrieben."
        },
        "hint2": {
          "part1": "Hinweis: ",
          "part2": "Dieser Vorgang kann einige Zeit in Anspruch nehmen und Sie können erst dann wieder neue Raten über den Preiskalender freigeben, wenn dieser abgeschlossen ist. Bitte vergewissern Sie sich, dass Sie Ihre Änderungen abgeschlossen haben, bevor Sie die Synchronisierung starten. Nach Abschluss wird hier und im Aktivitätsprotokoll eine Erfolgs- oder Fehlermeldung angezeigt."
        },
        "message": "Sind Sie sicher, dass Sie fortfahren möchten? Sie sind dabei, die bereits akzeptierten Raten für alle Zimmertypen (einschließlich neuer Einstellungen) an alle angeschlossenen PMS und CM zu senden.",
        "title": "Resynchronisierung"
      },
      "refresh": "Aktualisieren",
      "resyncCompleted": "Resynchronisierung abgeschlossen",
      "resyncFailed": "Resynchronisierung fehlgeschlagen",
      "resyncFailedHint": "Die Resynchronisierung ist fehlgeschlagen, öffnen Sie das Fehlerprotokoll, um die Details zu überprüfen.",
      "resyncInProgress": "In Arbeit",
      "resyncInProgressHint": "Dies kann eine Weile dauern. Sobald der Vorgang abgeschlossen ist, können Sie die Resynchronisierung wiederholen oder neue Raten über das Änderungsprotokoll senden.",
      "title": "Resynchronisierung"
    },
    "roomCategory": "Zimmerkategorie",
    "sidebar": {
      "autopilot": {
        "fixRates": "Raten fixieren",
        "forAllSelectedDays": "Für ausgewählte Tage",
        "hint1": {
          "message": "Mit der Aktivierung dieser Funktion fixieren Sie die aktuelle Rate für die ausgewählte Zimmerkategorie. Der Autopilot bleibt inaktiv und Sie können Ihre Raten ausschließlich manuell verwalten."
        },
        "noAutopilotMessage": "An mindestens einem Ihrer ausgewählten Tage ist kein Autopilot aktiviert.",
        "title": "Autopilot",
        "unfixRates": "Ratenfixierung aufheben"
      },
      "cancel": {
        "title": "Abbrechen"
      },
      "overview": {
        "competitors": {
          "cancellable": "Stornierbar",
          "competitor": "Mitbewerber",
          "empty": "Für dieses Datum sind keine Mitbewerberpreise verfügbar.",
          "mealType": {
            "allInclusive": "All inclusive",
            "breakfast": "Frühstück",
            "fullBoard": "Vollpension",
            "halfBoard": "Halbpension"
          },
          "title": "Mitbewerber"
        },
        "events": {
          "empty": "Für das gewählte Datum sind keine Events hinterlegt.",
          "title": "Events"
        },
        "forCategory": "Kategorie",
        "forHotel": "Hotel",
        "hint1": {
          "message": "Genaueres über die Auslastung, Forecast, Pickup und Mitbewerber erfahren Sie im ",
          "messageLink": "Support Bereich",
          "messageStop": ".",
          "title": "Erklärung"
        },
        "notes": {
          "addNew": "Notiz hinzufügen",
          "edit": "Notiz bearbeiten",
          "from": "Von",
          "noteNotSaved": "Notiz konnte nicht gespeichert werden. Bitte versuchen Sie es erneut",
          "placeholder": "Ihre Notiz",
          "title": "Notizen",
          "to": "auf",
          "warningDeletion": "Diese Aktion kann nicht rückgängig gemacht werden. Sind Sie sicher, dass die Notiz gelöscht werden soll?"
        },
        "statistics": {
          "adr": "ADR",
          "forecastErrorCodes": {
            "calculationError": "Forecast konnte nicht berechnet werden",
            "maximumDates": "Es können maximal 3 Tage ausgewählt werden",
            "onlyForHotel": "Forecast nur für das gesamte Hotel verfügbar",
            "someInvalid": "Kein Forecast für einige der ausgewählten Tage",
            "unexpected": "Ein unerwarteter Fehler ist aufgetreten"
          },
          "forecastFinal": "Forecast/Final",
          "forSelectedDays": "Daten für die gewählten Tage",
          "groupBlocks": "Gruppenblöcke",
          "occupancy": "Auslastung",
          "occupancyBlocks": "Auslastung inkl. Blöcke",
          "pickup": "Heutiger Pickup | Gestriger Pickup | Pickup {count} Tage",
          "revenue": "Umsatz",
          "revPar": "RevPar",
          "vacantRooms": "Freie Zimmer",
          "vacantRoomsBlocks": "Freie Zimmer inkl. Blöcke"
        },
        "title": "Übersicht"
      },
      "rateDescriptions": {
        "baseRate": "Basisrate",
        "modifierTypes": {
          "derivation": "Ableitung",
          "matrix": "Algorithmus",
          "min": "Untergrenze",
          "minMax": "Ratenlimit",
          "minMaxMax": "Ratenlimit MAX",
          "minMaxMin": "Ratenlimit MIN",
          "rateRounding": "Rundung",
          "rateRule": "Regel: {modifierName}",
          "rateRules": "Regeln"
        },
        "primaryRecommendation": "Primäre Empfehlung",
        "recommendedRate": "Empfohlene Rate",
        "title": "Berechnung"
      },
      "ratePlans": {
        "closed": "Geschlossen",
        "closeOpen": "Close/open",
        "closeOpenDisabled": "Der Close/open Status muss direkt im PMS/CM gesetzt werden.",
        "forAllCategories": "Für alle Zimmerkategorien übernehmen",
        "hint1": {
          "message": "Rate Plans werden mit dem Tür-Symbol geöffnet oder geschlossen. Die Ableitung von der Basisrate kann mit einem Prozentsatz oder einem Betrag angepasst werden.",
          "title": "Schritt 1"
        },
        "hint2": {
          "message": "Überprüfen Sie Ihre Änderungen im Protokoll unterhalb des Kalenders.",
          "title": "Schritt 2"
        },
        "hint3": {
          "message": "Zuletzt geben Sie das Protokoll mit Ihren Änderungen verbindlich frei.",
          "title": "Schritt 3"
        },
        "noChange": "Keine Änderung",
        "open": "Offen",
        "perPerson": "Pro Person",
        "perUnit": "Pro Wohneinheit",
        "title": "Rate Plans"
      },
      "rates": {
        "acceptAll": "Alle akzeptieren",
        "acceptAllText": "Alle Vorschläge übernehmen",
        "adjust": "Anpassen",
        "adjustment": "Anpassung",
        "allCategories": "Alle Kategorien",
        "autopilotMessage": "An mindestens einem Ihrer ausgewählten Tage ist der Autopilot aktiviert. Um einen Preis manuell zu definieren, müssen Sie die Preisfixierung aktivieren.",
        "baseRates": "Basisraten",
        "default": "Standard",
        "forCategory": "Kategorie",
        "forHotel": "Hotel",
        "hint1": {
          "message": "Speichern Sie Ihre vorläufigen Änderungen, um sie in den Kalender zu übernehmen.",
          "title": "Schritt 1"
        },
        "hint2": {
          "message": "Überprüfen Sie Ihre Änderungen im Protokoll unterhalb des Kalenders.",
          "title": "Schritt 2"
        },
        "hint3": {
          "message": "Senden Sie die Änderungen an Ihre aktiven Channels.",
          "title": "Schritt 3"
        },
        "hint4": {
          "message": "Wenn Sie die primäre Rate ändern, werden auch alle abgeleiteten Zimmertypen entsprechend geändert. Sie können die Ableitung hier individuell anpassen.",
          "title": "Raten ändern"
        },
        "hint5": {
          "message": "Wenn Sie die primäre Rate ändern, werden auch alle abgeleiteten Zimmertypen entsprechend geändert.",
          "message2": "Die Raten werden nur an Tagen und in Kategorien OHNE aktiven Autopiloten aktualisiert.",
          "title": "Raten ändern"
        },
        "notSet": "Nicht gesetzt",
        "rateStatus": {
          "baseInvalid": "Basisrate liegt außerhalb der Preisspanne.",
          "basePriceLevelMissing": "Fehlende Preisspanne.",
          "checkChangeLog": "Änderungen befinden sich zur Überprüfung im Änderungsprotokoll.",
          "derivedInvalid1": "Rate für Zimmertyp",
          "derivedInvalid2": "außerhalb der Preisspanne.",
          "derivedPriceLevelMissing1": "Fehlende Preisspanne für Zimmertyp",
          "derivedPriceLevelMissing2": ".",
          "error": "Fehler",
          "success": "Erfolgreich"
        },
        "restoreDefault": "Standard wiederherstellen",
        "title": "Raten"
      },
      "restrictions": {
        "closed": "Geschlossen",
        "cta": "Geschlossen für Anreisen (CTA)",
        "ctd": "Geschlossen für Abreisen (CTD)",
        "current": "Aktuell",
        "forAllCategories": "Diese Einstellungen für alle Zimmerkategorien übernehmen.",
        "hint1": {
          "message": "Restriktionen in den Kalender und das Protokoll übernehmen.",
          "title": "Schritt 1"
        },
        "hint2": {
          "message": "Überprüfen Sie Ihre Änderungen im Protokoll unterhalb des Kalenders.",
          "title": "Schritt 2"
        },
        "hint3": {
          "message": "Restriktionen an angeschlossene Systeme senden.",
          "title": "Schritt 3"
        },
        "maxLos": "Maximalaufenthaltsdauer (MaxLOS)",
        "minLos": "Mindestaufenthaltsdauer (MinLOS)",
        "new": "Neu",
        "notSet": "Nicht gesetzt",
        "notSupported": "Diese Einstellung wird von Ihrem PMS/CM nicht unterstützt.",
        "notSupportedEnabled": "Restriktion von Ihrem PMS/CM nicht unterstützt oder deaktiviert",
        "open": "Offen",
        "outOfRange": "MinLOS kann nicht größer als MaxLOS sein!",
        "setToZero": "Wenn MinLOS oder MaxLOS auf Null gesetzt werden, wird diese Restriktion gelöscht.",
        "step1": {
          "message": "Datei hochladen."
        },
        "step2": {
          "compare": "Vergleichen",
          "dateFormat": "Datumsformat",
          "excludedRooms": "Ausgeschlossene Zimmer",
          "header": "Header ist in der Datei enthalten",
          "message": "Alle Pflichtfelder zuordnen.",
          "settings": "Einstellungen"
        },
        "title": "Restriktionen",
        "upTo": "bis"
      }
    },
    "smallScreen": {
      "message1": "Es sieht so aus als würden Sie den Kalender auf einem kleinen Bildschirm betrachten.",
      "message2": "Um Ihnen optimale Sichtbarkeit und Editierbarkeit zu gewährleisten wird der Kalender erst ab höheren Auflösungen eingeblendet.",
      "title": "Kleiner Bildschirm"
    },
    "title": "Preiskalender",
    "today": "Heute"
  },
  "marketTrends": {
    "chartHeader": {
      "amountOfSearches": "Anzahl der Suchanfragen",
      "userLocationMap": "Standort des Benutzers",
      "weeklySearchTrends": "Wöchentliche Suchtrends",
      "yearlySearchTrends": "Jährliche Suchtrends"
    },
    "chartLabel": {
      "weeklySearchTrends": {
        "for": "Gesuchter Wochentag",
        "on": "Suche am Wochentag"
      },
      "yearlySearchTrends": {
        "current": "Laufendes Jahr",
        "forecast": "Prognose",
        "past": "Vergangenes Jahr"
      }
    },
    "from": "Von",
    "gridItem": {
      "ninety": {
        "title": "Gesamte Suche",
        "underline": "Letzte 90 Tage"
      },
      "thirty": {
        "title": "Gesamte Suche",
        "underline": "Letzte 30 Tage"
      },
      "trending": {
        "title": "Aktuell im Trend",
        "trendingMonth13": "Ostern",
        "trendingMonth14": "Neujahr"
      }
    },
    "newUi": {
      "amountOfSearchesTooltip": "Zeigt die tägliche Anzahl der Suchanfragen für das ausgewählte Gebiet und den ausgewählten Zeitraum.",
      "weeklySearch": "Wöchentliche Suche",
      "yearlySearchTrend": "Jährlicher Suchtrend"
    },
    "pageHeader": {
      "dateRange": "Suchanfragen von-bis",
      "title": "Markttrends"
    },
    "regionOfInterest": {
      "country": "Land",
      "label": "Gesucht in:",
      "region": "Provinz",
      "zip": "Postleitzahl"
    },
    "to": "bis"
  },
  "modal": {
    "title": {
      "add": "Neu"
    }
  },
  "netGrossSwitch": {
    "gross": "Brutto",
    "label": "Umsatz:",
    "net": "Netto",
    "tooltip": "Die Auswahl ändert die Daten für eingehende Umsätze von netto zu brutto (und umgekehrt). Die Umsätze ändern sich nur für Seiten, die diesen Schalter anzeigen."
  },
  "next": "Weiter",
  "no": "Nein",
  "notifications": {
    "banner": {
      "later": "Später",
      "title": "Es gibt neue Systemwarnungen"
    },
    "notifications": "Benachrichtigungen",
    "panel": {
      "empty": "Sieht aus, als wäre alles erledigt"
    },
    "payload": {
      "unmappedRoomTypesCount": "Sie haben einen nicht zugeordneten Zimmertyp. Bitte ordnen Sie diesen einer Kategorie in der Inventar Verwaltung zu. | Sie haben {count} nicht zugeordnete Zimmertypen. Bitte ordnen Sie diese einer Kategorie in der Inventar Verwaltung zu.",
      "unmappedSegmentsCount": "Sie haben ein nicht zugeordnetes Segment | Sie haben {count} nicht zugeordnete Segmente"
    },
    "solveNow": "Beheben",
    "systemAlerts": "Systemwarnungen",
    "tag": {
      "roomType": {
        "unmappedRoomTypes": "Unzugeordnete Zimmertypen"
      },
      "segment": {
        "unmappedSegments": "Unzugeordnete Segmente"
      }
    }
  },
  "ok": "OK",
  "pageHeader": {
    "datesText": "Geloggte Änderungen von-bis:"
  },
  "pageNotFound": {
    "customError": "Fehler",
    "error": "Fehler {status}",
    "errorMessage": {
      "401": "Oh! Sie haben keine Berechtigung zum Anzeigen dieser Seite. Bitte stellen Sie sicher, dass Sie eingeloggt sind.",
      "403": "Sie haben leider nicht die erforderlichen Berechtigungen, um diese Seite anzuzeigen. Bitte wenden Sie sich für weitere Hilfe an den Support.",
      "404": "Oh nein, die Seite, die Sie suchen, existiert nicht.",
      "500": "Tut uns leid, bei uns ist etwas schief gelaufen. Bitte versuchen Sie es später noch einmal.",
      "503": "Tut uns leid, wir haben im Moment technische Schwierigkeiten. Bitte versuchen Sie es später noch einmal.",
      "NoActiveHotel": "Diesem Benutzer ist kein aktives Hotel zugewiesen. Bitte kontaktieren Sie Ihren Support Manager für weitere Informationen."
    },
    "goToDashboard": "Weiter zum Dashboard",
    "redirectMessage1": "Sie werden in",
    "redirectMessage2": "Sekunden zum Dashboard weitergeleitet."
  },
  "pickup": {
    "distribution": {
      "graph": {
        "otb": "OTB",
        "roomNightsCancelled": "Zimmernächte storniert",
        "roomNightsConfirmed": "Zimmernächte bestätigt"
      },
      "header": "PickUp Verteilung",
      "table": {
        "cancellations": "Stornierungen",
        "cancellationsRevenue": "Umsatz Stornierungen",
        "currentLabel": "Auswahl",
        "month": "Monat",
        "otb": "OTB",
        "otbRevenue": "Umsatz OTB ",
        "pickup": "Pickup",
        "pickupRevenue": "Umsatz Pickup",
        "referenceLabel": "Referenz",
        "roomNights": "Zimmernächte",
        "totalRevenue": "Gesamtumsatz",
        "vacantRooms": "Freie Zimmer"
      },
      "tooltips": {
        "graph": "Zeigt an, wie der PickUp für den ausgewählten Datumsbereich über zukünftige Tage/Monate verteilt ist.",
        "graphHeader": "Diagramm “Pickup-Verteilung”",
        "table": "Zeigt die zusammengefassten Ergebnisse Monat für Monat an.",
        "tableHeader": "Tabelle “PickUp-Verteilung”"
      }
    },
    "filters": {
      "cancelledPickup": {
        "label": "Zimmernächte storniert",
        "options": {
          "hide": "Ausblenden",
          "show": "Anzeigen"
        }
      },
      "datePicker": {
        "label": "Zeitraum",
        "ranges": {
          "last14Days": "Letzte 14 Tage",
          "last7Days": "Letzten 7 Tage",
          "lastMonth": "Letzter Monat",
          "thisMonth": "Dieser Monat",
          "thisWeek": "Diese Woche"
        },
        "tooltip": "Wählen Sie hier Ihren gewünschten Zeitraum aus, maximal 1 Jahr"
      },
      "groupBy": {
        "label": "Gruppieren nach",
        "options": {
          "none": "Kein",
          "roomCategory": "Zimmerkategorie",
          "segment": "Segment"
        },
        "tooltip": "Die Gruppierung nach Segmentierung wird nur unterstützt, wenn die Kategorisierung der Segmente für Ihr Hotel aktiviert ist. (diese finden Sie unter Settings > Segmentierung)"
      },
      "kpi": {
        "label": "Kennzahl",
        "options": {
          "revenue": "Umsatz",
          "roomNights": "Zimmernächte"
        }
      },
      "reference": {
        "label": "Referenz",
        "options": {
          "none": "Nicht gewählt",
          "previous2Years": "2 Jahre vorher",
          "previousYear": "Vorjahr",
          "sameDate": "Selbes Datum",
          "sameDateOfWeek": "Selber Wochentag"
        }
      }
    },
    "from": "Von",
    "pageHeader": "PickUp",
    "pickupPerDay": {
      "errorMessages": {
        "failedToFetchData": "Wir konnten die erforderlichen Daten nicht laden. Bitte versuchen Sie es später erneut.",
        "noData": "Keine Daten für die ausgewählten Filter verfügbar. Versuchen Sie eine andere Kombination."
      },
      "graph": {
        "cancelled": "Storniert",
        "confirmed": "Bestätigt",
        "gained": "Bestätigt",
        "reference": "Referenz",
        "referenceCancelled": "Referenz storniert",
        "referenceConfirmed": "Referenz bestätigt",
        "referenceGained": "Referenz bestätigt",
        "referenceRevenue": "Umsatz aus Referenzzeitraum",
        "referenceRoomNights": "Referenzen Zimmernächte",
        "revenue": "Umsatz",
        "revenueCancelled": "Umsatz storniert",
        "revenueGained": "Umsatz bestätigt",
        "roomNights": "Zimmernächte",
        "roomNightsCancelled": "Zimmernächte storniert",
        "roomNightsConfirmed": "Zimmernächte bestätigt",
        "segmentData": {
          "complimentary": "Freinächte",
          "group": "Gruppen",
          "groupType": {
            "complimentary": "isComplimentary",
            "group": "isGroup",
            "none": "none"
          },
          "none": "Regulär"
        }
      },
      "header": "Pickup pro Tag",
      "table": {
        "adr": "ADR",
        "cancellations": "Stornierungen",
        "cancellationsRevenue": "Stornierungen Umsätze",
        "group": "Gruppierung",
        "pickup": "Pickup",
        "pickupRevenue": "Pickup-Umsätze",
        "roomNights": "Zimmernächte",
        "totalRevenue": "Gesamtumsatz"
      },
      "tooltips": {
        "graph": "Zeigt die ausgewählte KPI-Verteilung über den Datumsbereich an. Der Pickup kann weiterhin gruppiert werdern.",
        "graphHeader": "Diagramm „PickUp pro Tag“",
        "table": "Zeigt die zusammengefassten Ergebnisse für jede Gruppierung an, sofern ausgewählt.",
        "tableHeader": "Tabelle „Pickup pro Tag“"
      }
    },
    "summary": {
      "header": "Zusammenfassung",
      "titles": {
        "adr": "ADR",
        "cancellations": "Stornierungen",
        "pickupRoomNight": "PickUp",
        "revenue": "Gesamtumsatz"
      },
      "tooltips": {
        "adr": "Zeigt den durchschnittlichen Tagespreis für den gewählten Zeitraum an. Wenn Sie im Filter eine Referenz gewählt haben, wird ein Vergleich angezeigt.",
        "cancellations": "Zeigt die Stornierungen an, welche während des gewählten Zeitraums getätigt wurden. Wenn Sie im Filter eine Referenz gewählt haben, wird ein Vergleich angezeigt.",
        "headerTooltip": "Zeigt die aufsummierten Resultate der angewandten Filter. ",
        "pickupRoomNight": "Zeigt, wie viele Zimmernächte im gewählten Zeitraum gebucht wurden. Wenn Sie im Filter eine Referenz gewählt haben, wird ein Vergleich angezeigt.",
        "revenue": "Zeigt die Umsätze für den ausgewählten Datumsbereich an und vergleicht sie mit der ausgewählten Referenz."
      }
    },
    "to": "bis"
  },
  "report": "Melden",
  "reputation": {
    "averageRate": {
      "title": "Durchschnitt",
      "tooltip": "Durchschnittliche Bewertung der letzten 6 Monate."
    },
    "business": {
      "title": "Geschäftlich",
      "tooltip": "Durchschnittliche Gesamtbewertung basierend auf Geschäftsreisenden."
    },
    "couples": {
      "title": "Paare",
      "tooltip": "Durchschnittliche Gesamtbewertung basierend auf Paaren."
    },
    "family": {
      "title": "Familie",
      "tooltip": "Durchschnittliche Gesamtbewertung basierend auf Familiengästen."
    },
    "goodToKnow": "Gut zu wissen",
    "highlights": {
      "title": "Höhepunkte",
      "tooltip": "Die wichtigsten Themen über Ihr Hotel, basierend auf den Bewertungen Ihrer Gäste."
    },
    "nationality": {
      "title": "Nationalität",
      "tooltip": "Bewertungsverteilung basierend auf der Nationalität der Reisenden."
    },
    "noReviews": "Keine Bewertungen vorhanden",
    "overallDistribution": {
      "title": "Gesamtverteilung",
      "tooltip": "Wie sich Ihre Gäste auf die Kategorien Bewertung, Typ und Sprache verteilen"
    },
    "overallScore": {
      "averageScore": "/5",
      "last6Months": "Letzte 6 Monate",
      "reviews": "Bewertungen",
      "title": "Gesamtbewertung",
      "tooltip": "Durchschnittliche Gesamtbewertung Ihres Hotels, basierend auf der Gästekategorie."
    },
    "pageHeader": "Bewertungen",
    "poweredBy": "unterstützt durch",
    "rateDistribution": {
      "title": "Verteilung",
      "tooltip": "Bewertungsverteilung basierend auf der Punktzahl."
    },
    "relevantNow": {
      "title": "Jetzt relevant",
      "tooltip": "Wie Ihr Hotel in den letzten 6 Monaten bewertet wurde."
    },
    "reviewCount": {
      "reviews": "Bewertungen",
      "title": "Anzahl Bewertungen",
      "tooltip": "Monatliche Anzahl der Bewertungen in den letzten 6 Monaten."
    },
    "reviewLevel": "Bewertungsniveau",
    "scorePerCategory": {
      "noReviews": "Für diese Kategorie sind keine Bewertungen vorhanden.",
      "summary": "Zusammenfassung",
      "title": "Bewertung pro Kategorie",
      "tooltip": "Durchschnittswert und nützliche Informationen zu den wichtigsten Kategorien für Ihr Hotel."
    },
    "solo": {
      "title": "Alleinreisende",
      "tooltip": "Durchschnittliche Gesamtbewertung basierend auf Alleinreisenden."
    },
    "summary": "Zusammenfassung",
    "traveler": {
      "title": "Reisende",
      "tooltip": "Bewertungsverteilung basierend auf dem Reisetyp."
    }
  },
  "resetPassword": {
    "alert": {
      "success": "Neues Passwort festgelegt. Melden Sie sich bei Ihrem Konto an."
    }
  },
  "save": "Speichern",
  "search": "Suchen",
  "segmentation": {
    "descriptionOne": "Mithilfe dieses Tools können Reservierungen auf Basis Ihrer Segmente kategorisiert werden. Segmente werden in der Hotelsoftware/dem PMS gepflegt und an RateBoard übertragen. Die Segmentierung nimmt Einfluss auf die Ratenempfehlungen (Freinnächte von Mitarbeitern und Gruppenbuchungen werden nicht in die Nachfrage eingerechnet).",
    "descriptionOneNew": "Dieses Tool kann verwendet werden, um Reservierungen anhand ihrer Segmente als relevant oder nicht relevant für die Nachfrageberechnung zu kategorisieren. Der <b>Segmentierungstyp beeinflusst die Ratenempfehlung, da Buchungen mit \"Freinächte\" und \"Gruppen\" bei der Nachfrage nicht berücksichtigt werden.</b>",
    "descriptionTwo": "Ist diese Funktion aktiv, muss jedes (neue) Segment zugeordnet werden, die Auswahl von 'Freinächte', 'Gruppen', oder 'Keine' ist für jede Kategorie verpflichtend.",
    "descriptionTwoNew": "Segmente werden in der Hotelsoftware/dem PMS gepflegt und an RateBoard übertragen. Sobald die Segmentierung aktiviert ist, <b>müssen alle Segmente als \"Keine\", \"Freinächte\" oder \"Gruppen\" zugeordnet werden.</b>",
    "noSegments": "Keine Segmente",
    "noSegmentsTooltip": "Kann nicht aktiviert werden, da keine Segmente vorhanden sind.",
    "tableHeaders": {
      "complimentary": "Freinächte",
      "group": "Gruppen",
      "none": "Keine",
      "segment": "PMS Segment",
      "segmentationType": "Segmentierungstyp"
    },
    "title": "Segmentierung",
    "toggleButton": "Segmentierung Ein/Aus"
  },
  "select": {
    "empty": "Leer",
    "notSet": "Nicht gesetzt"
  },
  "session": {
    "expired": {
      "continue": "RateBoard weiterverwenden",
      "logout": "Logout",
      "message": "Wir haben seit einiger Zeit keine Aktivität festgestellt. Um Ihren Account sicher zu halten werden Sie automatisch ausgeloggt. Wenn Sie eingeloggt bleiben möchten klicken Sie bitte auf 'RateBoard weiterverwenden'.",
      "title": "Die Sitzung läuft demnächst ab"
    }
  },
  "settings": {
    "interface": {
      "apaleo": "APALEO",
      "channelManager": {
        "add": "Channel Manager hinzufügen",
        "addNew": "Neuen CM hinzufügen",
        "amountOfChannelsReached": "Maximale Anzahl an Channels erreicht.",
        "channelManager": "Channel Manager",
        "channelNotSaved": "Channel nicht gespeichert. Ein neuer Channel kann nicht erstellt werden.",
        "configuration": "CM-Konfiguration",
        "importUsersNotDisabled": "Bitte deaktivieren Sie alle aktiven Import-User oder löschen Sie den aktuellen FTP-User, bevor Sie das PMS ändern oder den Channel entfernen.",
        "integration": "Integration",
        "integrations": "Ihre Integrationen",
        "integrationsLabel": "Integrationen",
        "newIntegration": "Neue CM-Integration",
        "remove": "Channel Löschen"
      },
      "cmIntegration": "CM-Integration",
      "crawler": {
        "button": "ERNEUT IMPORTIEREN",
        "message": "Sind Sie sicher, dass Sie den Crawler starten wollen? Wählen Sie ein neues Startdatum oder verwenden Sie die Standardeinstellung (2 Jahre).",
        "modalTitle": "Crawler starten",
        "title": "CRAWLER"
      },
      "credentials": {
        "address": "API URL",
        "apiToken": "API Token",
        "connect": "Verbinden",
        "disconnect": "Trennen",
        "disconnectMessage": "Möchten Sie die Verbindung mit der Schnittstelle trennen?",
        "errorMessageValid": "Nicht alle Pflichtfelder wurden ausgefüllt.",
        "hotelCode": "Hotelcode",
        "idToken": "ID Token",
        "notConnected": "Nicht verbunden",
        "password": "Passwort",
        "save": "Credentials speichern",
        "saveMessage": "Möchten Sie die Schnittstellen Credentials wirklich speichern?",
        "title": "Default credentials",
        "username": "Benutzername"
      },
      "ftpCrawler": {
        "button": "ERNEUT IMPORTIEREN",
        "message": "Sind Sie sicher, dass Sie den Ftp Crawler starten wollen?",
        "modalTitle": "Ftp Crawler starten",
        "title": "ftp crawler"
      },
      "ftpImportCredentials": {
        "generate": "FTP-Benutzer generieren",
        "title": "Ftp import Zugangsdaten"
      },
      "importCredentials": {
        "active": "Aktiv",
        "alert": {
          "create": {
            "error": "Neuer Benutzer konnte nicht generiert werden.",
            "success": "Neuer Benutzer generiert."
          },
          "delete": {
            "error": "Benutzer konnte nicht gelöscht werden.",
            "success": "Benutzer gelöscht."
          },
          "disable": {
            "error": "Zugangsdaten wurden nicht deaktiviert.",
            "success": "Zugangsdaten wurden deaktiviert."
          },
          "enable": {
            "error": "Zugangsdaten wurden nicht aktiviert.",
            "success": "Zugangsdaten wurden aktiviert."
          }
        },
        "disabled": "Deaktiviert",
        "generate": "Benutzer generieren",
        "modal": {
          "delete": "Diese Aktion kann nicht rückgängig gemacht werden. Sind Sie sicher, dass Sie den Benutzer {username} löschen wollen?",
          "disable": "Sind Sie sicher, dass Sie Benutzer {username} DEAKTIVIEREN wollen? Diese Aktion stoppt die Importe mit diesen Zugangsdaten.",
          "generate": {
            "password": "Passwort",
            "title": "Neuer Benutzer generiert",
            "username": "Name",
            "warning": "Achtung",
            "warningText": "Das Passwort wird nach diesem Schritt ausgeblendet, bitte notieren Sie es, bevor Sie fortfahren."
          }
        },
        "newUiGenerate": "Import-Benutzer generieren",
        "title": "Import Zugangsdaten"
      },
      "inbound": {
        "generalInformation": "Allgemeine Infos",
        "guaranteeType": "Guarantee Type für Optionen",
        "importInventoryFromPMS": "Inventory von PMS importieren",
        "title": "Inbound Konfiguration"
      },
      "interfaceConfiguration": "Schnittstellen Konfiguration",
      "outbound": {
        "ageCategories": "Altersgruppen",
        "ageQualifyingCode": "Age Qualifying Code",
        "allFieldsRequired": "Nicht alle Pflichtfelder wurden ausgefüllt.",
        "applyTo": "Übernehmen",
        "chargeType": "Zahlungsart",
        "externalSettingsFetchingError": "Es gab ein Problem die Zimmertypen/Ratenpläne vom PMS abzufragen. Sind die Zugangsdaten korrekt?",
        "generalInformation": "Allgemeine Infos",
        "ignored": "Ignoriert",
        "maxLos": "MaxLOS",
        "mealPlan": {
          "allInclusive": "All Inclusive",
          "bedAndBreakfast": "Bed & Breakfast",
          "fullBoard": "Vollpension",
          "halfBoard": "Halbpension",
          "mealType": "Verpflegungstyp",
          "roomOnly": "Room Only"
        },
        "minLos": "MinLOS",
        "noActiveRatePlans": "Mindestens ein Rate Plan pro Interface muss aktiviert sein.",
        "noActiveRoomTypes": "Bitte zumindest einen Zimmertypen mappen.",
        "noActiveRoomTypesRatePlans": "Bitte zumindest einen Zimmertypen mappen für aktivierten Rate Plan.",
        "noMappedMealPlan": "Die Zuordnung des Verpflegungstyps fehlt für die aktivierten Ratenpläne.",
        "noMappedRatePlanTitle": "Mapping für aktivierten Rate Plan fehlt.",
        "noMappedRoomTypeTitle": "Keine Zimmertypen.",
        "perPerson": "Pro Person",
        "perRoom": "Pro Zimmer",
        "productCode": "Product code",
        "publish": "Daten senden",
        "ratePlanCategory": "Ratenplankategorie",
        "ratePlanCategoryCode": "rate plan category code",
        "ratePlanCode": "rate plan code",
        "ratePlans": "Ratenpläne",
        "restrictionsSettings": "Restriktionseinstellungen",
        "roomType": "Zimmertyp",
        "roomTypes": "Zimmertypen",
        "title": "Outbound Konfiguration"
      },
      "pmsConfiguration": "PMS Konfiguration",
      "pmsIntegration": "PMS-Integration",
      "pmsSelection": {
        "pms": "PMS"
      },
      "restrictions": {
        "closed": "Geschlossen",
        "cta": "Geschlossen für Anreisen (CTA)",
        "ctd": "Geschlossen für Abreisen (CTD)",
        "maxLos": "MaxLOS",
        "minLos": "MinLOS",
        "title": "Unterstützte Restriktionen"
      }
    },
    "inventory": {
      "capacity": {
        "addButton": {
          "newUiText": "Neue Kapazität",
          "text": "Neu..."
        },
        "addModal": {
          "message": "Wählen Sie das Startdatum für die neue Zimmerkapazität. Ab diesem Datum wird die aktualisierte Zimmeranzahl verwendet.",
          "submit": "Neue Kapazität hinzufügen",
          "title": "Zimmerkapazität hinzufügen"
        },
        "cardTitle": "Kapazität",
        "changeDateDialog": {
          "message": "Wählen Sie das neue Startdatum, ab dem diese Zimmerkapazität gelten soll.",
          "newUiTitle": "Startdatum der Kapazität bearbeiten",
          "title": "Datum ändern"
        },
        "datePicker": {
          "changeDate": "Datum ändern",
          "fromLabel": "Von:",
          "label": "Datum:"
        },
        "deleteImpossibleTooltipText": "Eintrag kann nicht gelöscht werden. Für mindestens 3 Jahre müssen Inventory-Einträge vorhanden sein.",
        "deleteModal": {
          "message": "Möchten Sie diese Zimmerkapazität wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
          "title": "Kapazität löschen"
        },
        "details": "Details",
        "error": {
          "collidingDate": "Es gibt bereits einen Eintrag mit dem Datum {date}.",
          "threeYearsRequired": "Mindestens ein Eintrag welcher 3 Jahre oder mehr zurückliegt ist erforderlich.",
          "totalAtLeastOne": "Die Gesamtzahl der Zimmer muss mindestens 1 betragen."
        },
        "manualSettingNotPossible": {
          "text": "Wir importieren die Kapazitätsinformationen direkt aus dem PMS. \nDie manuelle Kapazitätskonfiguration ist deaktiviert.",
          "title": "Manuelle Einstellung der Kapazitäten nicht möglich."
        },
        "options": "Options",
        "roomsAndCount": "Rooms and count",
        "totalAvailable": {
          "label": "Gesamt:",
          "newUiLabel": "Zimmer gesamt:"
        }
      },
      "configuration": {
        "confirmationMessage1": "Eine Änderung der Zuordnung der Zimmertypen <> Zimmerkategorien führt zu folgenden Änderungen in den Preisstufen:",
        "confirmationMessage2": "Preisstufen mit Ableitungen in % vom Primärtypen werden ALLE automatisch auf den entsprechenden Wert in €-Beträge geändert.",
        "confirmationMessage3": "Wenn dies nicht gewünscht ist, bitten wir diesen Vorgang abzubrechen und Kontakt mit unserem Support Team unter ",
        "confirmationMessage4": "aufzunehmen. Preisstufen mit Ableitungen in € vom Primärtypen bleiben in der Basis bestehen.",
        "confirmationMessage5": "Hier bitten wir nach dem Speichervorgang die Minimum- und Maximumwerte zu kontrollieren und ggf. anzupassen.",
        "errorMessage": "Bitte stellen Sie sicher, dass alle Felder ausgefüllt sind und für jede Zimmerkategorie genau ein Primärtyp gewählt ist.",
        "options": "Optionen",
        "pmsTitle": "Liste aller PMS Zimmertypen",
        "priceWarning": "Der Wechsel des Primärtyps oder der zugewiesenen Kategorien kann im Bereich \"Settings > Preisstufen\" zu Fehlern führen. Bitte Überprüfe deine Einstellungen im Anschluss!!!",
        "roomBlocksSwitch": "Gruppenblocks berücksichtigen",
        "roomTypeCreation": {
          "button": "Zimmertyp erstellen",
          "duplicateName": "Ein Zimmertyp mit diesem Namen existiert bereits, bitte anderen Namen verwenden.",
          "modalContent": "Sind Sie sicher, dass Sie einen neuen Zimmertyp erstellen möchten? Bitte verwenden Sie eine verständliche Bezeichnung.",
          "modalTitle": "Neuen Zimmertyp erstellen",
          "placeholder": "ROOMX"
        },
        "showExcludedRooms": "Ausgeschlossene Zimmertypen anzeigen",
        "table": {
          "category": "Kategorie",
          "options": {
            "active": "Aktiv",
            "archived": "Archiviert",
            "excluded": "Ausgeschlossen",
            "header": "Optionen"
          },
          "primary": "Primär",
          "roomType": "Zimmertyp"
        },
        "unresolvableWarning": "Überschriebene Preis-Einstellungen konnten für die folgenden Tage nicht berechnet werden: {dates}. Übersteuerung wird gelöscht. Möchen Sie fortfahren?",
        "warningTitle": "ACHTUNG!"
      },
      "tabs": {
        "capacity": "Kapazität",
        "configuration": "Konfiguration"
      },
      "title": "Inventar Verwaltung"
    },
    "notificationRules": {
      "conditions": {
        "adr": {
          "summaryAverage": "ADR Durchschnittswert ist {operator} {value} für {category}",
          "summaryDaily": "ADR ist täglich {operator} {value} für {category}"
        },
        "autopilot": {
          "increaeOrDecrease": "erhöht oder senkt den Preis um mehr als",
          "summary": "Autopilot erhöht oder senkt den Preis um mehr als {deviation}"
        },
        "availability": {
          "summaryAverage": "{operator} {available} freie Zimmer sind durchschnittlich verfügbar für {category}",
          "summaryDaily": "{operator} {available} freie Zimmer sind täglich verfügbar für {category}"
        },
        "cancellation": {
          "moreThan": "Mehr als",
          "roomsFor": "Zimmer storniert in den letzten",
          "summary": "Mehr als {value} Zimmer storniert in den letzten {days}"
        },
        "capping": {
          "comparables": {
            "maximum": "Maximalwert",
            "minimum": "Minimalwert"
          },
          "summary": "Capping {comparable} wurde für einen laufenden zukünftigen Zeitraum von {days} erreicht",
          "valueIsReached": "wurde für einen laufenden zukünftigen Zeitraum von",
          "valueIsReachedAfter": "erreicht.",
          "valueIsReachedBefore": ""
        },
        "categoryConstraints": {
          "comparables": {
            "higher": "höher",
            "lower": "niedriger"
          },
          "is": "ist",
          "rateOf": "Preis von",
          "summary": "Preis von {categoryId1} ist {comparable} als {categoryId2}",
          "than": "als"
        },
        "dateRange": {
          "summaryShort": "{dateFrom} - {dateTo}"
        },
        "dba": {
          "summaryShort": "{from} Tage > DBA < {to} Tage"
        },
        "occupancy": {
          "summaryAverage": "Auslastung Durchschnittswert ist {operator} {value}% für {category}",
          "summaryDaily": "Auslastung ist täglich {operator} {value}% für {category}"
        },
        "pickup": {
          "roomsFor": "PickUp-Zimmer in den letzten",
          "summary": "{operator} {value} PickUp-Zimmer in den letzten {days}"
        },
        "rateLevel": {
          "undefined": "Preislevel (ID={id})"
        },
        "rateRecommendation": {
          "deviatesMore": "weicht mehr als",
          "fromTheActive": "von der aktiven Rate ab.",
          "summary": "Ratenempfehlung weicht mehr als {deviation} von der aktiven Rate ab"
        },
        "revpar": {
          "summaryAverage": "RevPAR Durchschnittswert ist {operator} {value} für {category}",
          "summaryDaily": "RevPAR ist täglich {operator} {value} für {category}"
        },
        "types": {
          "autopilot": "Autopilot",
          "cancellation": "Stornierung",
          "capping": "Capping",
          "categoryConstraints": "Kategoriebeschränkungen",
          "pickup": "Pickup",
          "rateRecommendation": "Ratenempfehlung",
          "yoyComparison": "YoY Vergleich"
        },
        "yoyComparison": {
          "are": "sind",
          "comparables": {
            "higher": "höher",
            "lower": "niedriger"
          },
          "compareTo": "Vergleiche mit",
          "comparisonDays": {
            "sameDate": "selben Datum",
            "sameWeekday": "selben Wochentag"
          },
          "dataTypes": {
            "adr": "ADR",
            "availability": "Freie Zimmer",
            "booking": "OTB Buchungen",
            "cancellations": "Stornierungen",
            "occupancy": "Auslastung",
            "pickup": "Pickup",
            "revenue": "OTB Umsatz",
            "revPar": "RevPar"
          },
          "is": "ist",
          "summaryAverage": "{dataType} {isOrAre} durchschnittlich {deviation} {comparable} als im Vorjahr. Vergleiche mit {comparisonDay}",
          "summaryAveragePickupOrCancellation": "{dataType} {isOrAre} durchschnittlich {deviation} {comparable} als im Vorjahr in den letzten {days}. Vergleiche mit {comparisonDay}",
          "summaryDaily": "{dataType} {isOrAre} täglich {deviation} {comparable} als im Vorjahr. Vergleiche mit {comparisonDay}",
          "summaryDailyPickupOrCancellation": "{dataType} {isOrAre} täglich {deviation} {comparable} als im Vorjahr in den letzten {days}. Vergleiche mit {comparisonDay}",
          "thanLastYear": "als im Vorjahr.",
          "thanLastYearForARunningPeriodOf": "als im Vorjahr in den letzten"
        }
      },
      "createRule": "Neue Benachrichtigung",
      "createRuleNew": "Neue Benachrichtigung",
      "days": "{n} Tagen",
      "deleteRule": {
        "title": "Benachrichtigung löschen"
      },
      "description": "Erstelle benutzerdefinierte Benachrichtigungen für dieses Hotel, exklusiv für deinen User. Aktiviere bis zu {n} Regeln.",
      "editCreateRule": {
        "conditions": {
          "summary": "Wenn die folgenden Bedingungen ...",
          "title": "Bedingungen ({n}/{max})",
          "titleTooltip": "Kombiniere bis zu {n} Bedingungen. Die Benachrichtigung wird ausgelöst, wenn alle Bedingungen erfüllt sind."
        },
        "createRule": "Neue Benachrichtigung",
        "editRule": "Benachrichtigung bearbeiten",
        "invalidTimeRange": "Mindestens ein DBA oder Datumsbereich muss festgelegt werden",
        "notificationType": {
          "summary": "benachrichtige mich per",
          "title": "Benachrichtigungstyp",
          "titleTooltip": "Wähle ob du über die App im Dashboard oder per E-Mail benachrichtigt werden möchtest."
        },
        "ruleName": "Benachrichtigungsname",
        "ruleNameTooltip": "Die Benachrichtigung kann später umbenannt werden. Wähle einen Namen, der den Zweck klar beschreibt.",
        "summaryLabels": {
          "for": "Für",
          "if": "Wenn"
        },
        "timeRange": {
          "add": "Zeitraum hinzufügen",
          "summary": "während dieses Zeitraums zutreffen ...",
          "title": "Zeitraum ({n}/{max})",
          "titleTooltip": "Mindestens ein DBA oder Datumsbereich muss hinzugefügt werden. Zeitraum-Bedingungen desselben Typs können nicht kombiniert werden."
        },
        "valueProvingType": {
          "buttonTemplate": "{type} Werte",
          "label": "Wertprüfungstyp",
          "labelTooltip": "Wähle, ob jeder Tag einzeln oder der Durchschnitt für den ausgewählten Zeitraum bewertet werden soll."
        }
      },
      "notificationRuleTable": {
        "actions": "Aktionen",
        "conditions": "Bedingungen",
        "conditionsAmountString": "{n}/{max}",
        "name": "Benachrichtigungsname",
        "notificationTypes": "Benachrichtigungstyp",
        "status": "Status",
        "statusTooltip": "Sie können bis zu {n} aktive Regeln haben.",
        "timeRangeConditions": "Zeitraum",
        "tooltip": {
          "delete": "Regel löschen",
          "edit": "Regel bearbeiten",
          "ruleActive": "Regel aktiv",
          "ruleInactive": "Regel inaktiv"
        }
      },
      "notificationTypes": {
        "types": {
          "dashboard": "In-app",
          "email": "E-mail"
        },
        "undefined": {
          "summary": "Noch keinen Benachrichtigungstyp festgelegt"
        }
      },
      "timeRanges": {
        "dateRange": {
          "exceeded": "Der Datumsbereich dieser Benachrichtigung ist veraltet. Bitte aktualisieren Sie ihn, um Benachrichtigungen zu erhalten."
        },
        "undefined": {
          "summary": "Noch kein Zeitraum festgelegt"
        }
      },
      "title": "Benachrichtigungen",
      "toast": {
        "activationFailed": "Wir konnten diese Benachrichtigung nicht aktivieren. Bitte versuchen Sie es später erneut oder wenden Sie sich an unser Support-Team, wenn das Problem weiterhin besteht.",
        "activationOk": "Die Benachrichtigung wurde erfolgreich aktiviert.",
        "changesFailed": "Wir konnten Ihre Änderungen nicht speichern. Bitte versuchen Sie es später erneut oder kontaktieren Sie unser Support-Team, wenn das Problem weiterhin besteht.",
        "changesOk": "Ihre Änderungen wurden gespeichert.",
        "deactivationFailed": "Wir konnten diese Benachrichtigung nicht deaktivieren. Bitte versuchen Sie es später erneut oder kontaktieren Sie unser Support-Team, wenn das Problem weiterhin besteht.",
        "deactivationOk": "Die Benachrichtigung wurde deaktiviert.",
        "deleteFailed": "Wir konnten diese Benachrichtigung nicht löschen. Bitte versuchen Sie es später erneut oder kontaktieren Sie unser Support-Team, wenn das Problem weiterhin besteht.",
        "deleteOk": "Die Benachrichtigung wurde gelöscht.",
        "maxActive": "Sie haben das Limit von {n} aktiven Regeln erreicht. Bitte deaktivieren Sie eine vorhandene Regel, bevor Sie diese aktivieren."
      },
      "valueProvingTypes": {
        "types": {
          "average": "durchschnittliche",
          "daily": "tägliche"
        }
      }
    },
    "rateRounding": {
      "methods": {
        "up": "Aufrunden auf",
        "up_down": "Auf- oder Abrunden auf",
        "up_down_multiples": "Auf- oder Abrunden auf Vielfache von",
        "up_multiples": "Aufrunden auf Vielfache von"
      },
      "noRounding": "Nicht runden",
      "title": "Preisrundung"
    },
    "rateRules": {
      "actions": {
        "directions": {
          "decrease": "senke",
          "increase": "erhöhe"
        },
        "rate": {
          "rateBy": "Rate um",
          "summary": "{direction} Rate um {value} für {category}"
        },
        "undefined": {
          "summary": "Noch keine Aktion festgelegt"
        }
      },
      "category": {
        "allCategories": "alle Kategorien",
        "customCategory": "Kategorie (ID={id})",
        "for": "für"
      },
      "computeRecommendations": "Empfehlungen berechnen",
      "conditions": {
        "adr": {
          "summary": "ADR ist {operator} {value} für {category}"
        },
        "are": "sind",
        "availability": {
          "areVacantFor": "sind verfügbar für",
          "rooms": "freie Zimmer",
          "summary": "{operator} {available} freie Zimmer sind verfügbar für {category}"
        },
        "competitors": {
          "comparables": {
            "average": "durchschnittlichen",
            "highest": "höchsten",
            "lowest": "niedrigsten"
          },
          "mine": "meine.",
          "ratesOf": "Raten für",
          "summary": "{comparable} Raten für {category} sind {offset}{operator} meine"
        },
        "dateRange": {
          "maxDiffTooltip": "Der Bereich darf eine Zeitspanne von {n} Tagen nicht überschreiten.",
          "summary": "Datumsbereich ist von {dateFrom} bis {dateTo}"
        },
        "dba": {
          "and": "und",
          "fromHigherTo": "Das untere DBA Limit kann nicht höher sein als das obere DBA Limit.",
          "isBetween": "ist zwischen",
          "maxDbaDiffExceeded": "Der DBA Bereich darf eine Zeitspanne von {n} Tagen nicht überschreiten.",
          "maxDbaExceeded": "Diese Bedingung kann bis zu {n} Tage lang ausgewertet werden.",
          "maxDbaTooltip": "Die zu bewertende Zeit kann bis zu {n} Tage in die Zukunft reichen.",
          "summary": "DBA ist zwischen {from} und {to} Tage"
        },
        "event": {
          "notSet": "nicht gesetzt",
          "onTheDate": "am betroffenen Tag.",
          "set": "gesetzt",
          "summary": "Event ist {set} am betroffenen Tag"
        },
        "is": "ist",
        "occupancy": {
          "summary": "Auslastung ist {operator} {occupancy}% für {category}"
        },
        "of": "von",
        "rateLevel": {
          "isActiveFor": "ist aktiv für",
          "summary": "Preislevel '{rateLevel}' ist aktiv für {category}"
        },
        "revPar": {
          "summary": "RevPAR ist {operator} {revPar} für {category}"
        },
        "types": {
          "adr": "ADR (Average Daily Rate)",
          "availability": "Freie Zimmer",
          "competitors": "Mitbewerber",
          "dateRange": "Datumsbereich",
          "dba": "DBA (Days Before Arrival)",
          "event": "Event",
          "occupancy": "Auslastung",
          "rateLevel": "Preislevel",
          "revPar": "RevPAR (Revenue per available room)",
          "weatherForecast": "Wettervorhersage",
          "weatherTemperature": "Temperatur",
          "weatherWindSpeed": "Windstärke",
          "weekday": "Wochentage"
        },
        "undefined": {
          "summary": "Noch keine Bedingung festgelegt"
        },
        "weatherForecast": {
          "comparables": {
            "cloudy": "bewölkt",
            "misty": "nebelig",
            "rainy": "regnerisch",
            "snowy": "verschneit",
            "sunny": "sonnig"
          },
          "onAffectedDay": "am betroffenen Tag.",
          "summary": "Die Wettervorhersage ist {comparable} am betroffenen Tag"
        },
        "weatherTemperature": {
          "comparables": {
            "average": "durchschnittliche",
            "maximum": "maximale",
            "minimum": "minimale"
          },
          "summary": "{comparable} Temperatur ist {operator} {temperature}",
          "temperatureIs": "Temperatur ist"
        },
        "weatherWindSpeed": {
          "summary": "Windstärke ist {operator} {windSpeed}",
          "windSpeedIs": "Windstärke ist"
        },
        "weekday": {
          "summaryMany": "Wochentage sind {weekdays} und {lastWeekday}",
          "summaryOne": "Wochentag ist {weekday}"
        }
      },
      "createRule": "Neue Regel",
      "createRuleNew": "Neue Preisregel",
      "deleteRule": {
        "message": "Diese Aktion kann nicht rückgängig gemacht werden! Bist du sicher, dass du diese Regel entfernen möchtest?",
        "title": "Regel löschen"
      },
      "description": "Erstelle Regeln, um die Ratenempfehlungen für dieses Hotel anzupassen. Regeln werden auf die vom Algorithmus berechneten Empfehlungen angewendet.",
      "descriptionTwo": "Sie können bis zu {n} Regeln aktivieren.",
      "editCreateRule": {
        "actions": {
          "add": "Aktion hinzufügen",
          "summary": "... werden folgende Aktionen ausgeführt:",
          "title": "Aktionen",
          "titleTooltip": "Fügen Sie bis zu {n} Aktionen zur Regel hinzu. Wenn die Bedingungen erfüllt sind, werden alle Aktionen ausgeführt."
        },
        "conditions": {
          "add": "Bedingung hinzufügen",
          "none": "Keine",
          "summary": "Wenn die folgenden Bedingungen zutreffen ...",
          "title": "Bedingungen",
          "titleTooltip": "Fügen Sie bis zu {n} Bedingungen zur Regel hinzu. Alle Bedingungen müssen erfüllt sein, damit die Aktionen ausgeführt werden können."
        },
        "createRule": "Neue Regel erstellen",
        "editRule": "Regel bearbeiten",
        "invalid": "Sie benötigen mindestens einen Regelnamen, eine Bedingung und eine Aktion, um eine Regel zu speichern. Sie können maximal {nC} Bedingungen und {nA} Aktionen hinzufügen.",
        "ruleName": "Regelname",
        "ruleNameTooltip": "Sie können den Namen der Regel später ändern. Wählen Sie einen Namen, der die neue Regel eindeutig beschreibt.",
        "summary": "Zusammenfassung"
      },
      "hotelOrCategory": {
        "category": "Zimmerkategorie",
        "hotel": "Hotel"
      },
      "operatorAlternatives": {
        "equalTo": "genau",
        "lessThan": "weniger als",
        "moreThan": "mehr als",
        "noLessThan": "nicht weniger als",
        "noMoreThan": "nicht mehr als"
      },
      "operators": {
        "equalTo": "gleich wie",
        "lessThan": "niedriger als",
        "moreThan": "höher als",
        "noLessThan": "nicht niedriger als",
        "noMoreThan": "nicht höher als"
      },
      "rateRule": {
        "accumulating": {
          "description": "Alle Regeln in diesem Abschnitt sind aktiv und werden ausgeführt, wenn die Bedingungen erfüllt sind.",
          "title": "Kumulierende Regeln"
        },
        "activeSince": "Aktiv seit {dateTime}",
        "and": "und",
        "create": "erstellen",
        "hierarchical": {
          "description": "Alle Regeln in diesem Abschnitt sind aktiv. Die Regeln werden in hierarchischer Reihenfolge geprüft. Sie können die Reihenfolge per drag and drop ändern. Die erste Regel, die die Bedingungen erfüllt, wird angewendet. Alle nachfolgenden Regeln werden übersprungen.",
          "title": "Hierarchische Regeln"
        },
        "inactive": {
          "description": "Neue und inaktive Regeln werden in diesem Bereich gespeichert. Ziehen Sie eine beliebige Regel in den gewünschten Bereich (kumulierend oder hierarchisch), um sie zu aktivieren. Ziehen Sie die Regel zurück in diesen Bereich, um sie zu deaktivieren.",
          "title": "Inaktive Regeln"
        },
        "nActions": "{n} Aktionen|{n} Aktion|{n} Aktionen",
        "nConditions": "{n} Bedingungen|{n} Bedingung|{n} Bedingungen",
        "notDraggable": "Maximale Anzahl an aktiven Regeln erreicht"
      },
      "rateRuleContainer": {
        "order": "{order}°"
      },
      "title": "Preisregeln",
      "toast": {
        "computationRequestOk": "Die Raten werden neu berechnet. Das kann einige Minuten dauern."
      }
    }
  },
  "sidebar": {
    "emptyPlaceHolder": "Hier gibt es nichts anzuzeigen!"
  },
  "termsOfUse": {
    "message": "Bitte lesen und akzeptieren Sie vor der Nutzung von RateBoard unsere Allgemeinen Geschäftsbedingungen und Datenschutzbestimmungen. Sie finden diese hier:",
    "messageNew": "Bevor Sie RateBoard nutzen, lesen und akzeptieren Sie unsere Nutzungsbedingungen und Datenschutzbestimmungen.",
    "title": "Allgemeine Geschäftsbedingungen"
  },
  "userSettings": {
    "accountSettings": {
      "defaultCompany": "Bei Start öffnen",
      "defaultCompanyTooltip": "Wählen Sie eine Unterkunft, die beim Start von RateBoard angezeigt werden soll.",
      "language": "Sprache",
      "locale": "Formatierung",
      "locales": {
        "AT": "Österreichisch",
        "CH": "Schweizerisch",
        "DE": "Deutsch",
        "FI": "Finnisch",
        "FR": "Französisch",
        "GB": "Englisch (GB)",
        "IT": "Italienisch",
        "US": "Englisch (US)"
      },
      "localeTooltip": "Das Datums- und Währungsformat wird entsprechend der ausgewählten Region eingestellt. Dies wirkt sich nicht auf die Region der Unterkunft aus.",
      "title": "Account Einstellungen"
    },
    "changePassword": {
      "confirmPassword": "Passwort wiederholen",
      "confirmPasswordPlaceholder": "Passwort wiederholen",
      "invalidOld": "Ungültiges altes Passwort!",
      "newPassword": "Neues Passwort",
      "newPasswordPlaceholder": "Neues Passwort",
      "notMatching": "Passwörter verschieden!",
      "oldPassword": "Altes Passwort",
      "oldPasswordPlaceholder": "Passwort",
      "save": "Neues Passwort speichern",
      "subtitle": "Neues Passwort wählen",
      "title": "Neues Passwort wählen",
      "titleNew": "Passwort ändern",
      "tooShort": "Ungültiges Passwort. Das Passwort muss mindestens 8 Zeichen lang sein und darf Sonderzeichen, jedoch keine Leerzeichen enthalten."
    },
    "overview": "Übersicht",
    "reports": {
      "frequency": {
        "DAILY": "Täglich",
        "MONTHLY": "Monatlich",
        "NEVER": "Nie",
        "WEEKLY": "Wöchentlich"
      },
      "performanceReport": "Performance Report",
      "pickupReport": "Pickup Report",
      "rateReport": "Raten Report",
      "title": "Reporte"
    },
    "resetPassword": {
      "title": "Passwort zurücksetzen"
    },
    "saveChanges": "Änderungen speichern",
    "savePassword": "Passwort ändern",
    "security": "Sicherheitseinstellungen",
    "title": "Benutzereinstellungen",
    "twoFactorAuthentication": {
      "addDevice": "Gerät hinzufügen",
      "addDeviceError": "Das 2FA-Gerät kann nicht hinzugefügt werden.",
      "addDeviceSuccess": "2FA-Gerät erfolgreich hinzugefügt.",
      "disabled": "Inaktiv",
      "enabled": "Aktiv",
      "otpInputField": "6-stelliger Code",
      "otpInvalid": "Falsches Passwort, bitte versuchen Sie es erneut",
      "otpMessage": "Geben Sie den Code Ihrer Authentifizierungs-App ein, um sicherzustellen, dass alles korrekt eingerichtet ist. Sobald die Verbindung hergestellt ist, speichern wir dieses Gerät, sodass Sie es beim Anmelden verwenden können.",
      "otpTitle": "Authentifizierungs-App verifizieren",
      "password": "Passwort",
      "passwordInvalid": "Falsches Passwort, bitte versuchen Sie es erneut",
      "qrCodeAccountName": "Kontoname: ",
      "qrCodeManual": "Oder geben Sie den Code manuell in Ihre Verifizierungs-App ein",
      "qrCodeManualCode": "Code: ",
      "qrCodeMessage": "Scannen Sie diesen QR-Code mit einer Sicherheits- oder Authentifizierungs-App wie Google Authenticator, Authy, Duo oder eines anderen vertrauenswürdigen Tools, das im App Store Ihres Geräts verfügbar ist.",
      "qrCodeTitle": "Scannen Sie den QR-Code mit der Authentifizierungs-App",
      "removeDevice": "Gerät entfernen",
      "removeDeviceError": "Das 2FA-Gerät kann nicht entfernt werden.",
      "removeDeviceMessage": "Geben Sie Ihr Passwort ein, um dieses Gerät zu deaktivieren und zu entfernen. Diese Aktion kann nicht rückgängig gemacht werden, aber Sie können später ein neues Gerät hinzufügen.",
      "removeDeviceSuccess": "2FA-Gerät erfolgreich entfernt und deaktiviert.",
      "removeDeviceTitle": "Zwei-Faktor-Authentifizierung entfernen",
      "setupMessage": "Geben Sie Ihr RateBoard-Passwort ein, um die Einrichtung zu starten.",
      "setupTitle": "Einrichtung Zwei-Faktor-Authentifizierung",
      "title": "Zwei-Faktor-Authentifizierung",
      "tooltip": "Es kann maximal ein Gerät angeschlossen werden"
    },
    "user": {
      "title": "Benutzereinstellungen",
      "userMail": "Benutzer E-Mail"
    }
  },
  "validation": {
    "max": "Maximale Anzahl von Zeichen überschritten",
    "min": "Mindestanzahl von Zeichen unterschritten",
    "required": "Erforderlich"
  },
  "warning": {
    "warning": "Achtung!",
    "warningDeletion": "Diese Aktion kann nicht rückgängig gemacht werden. Sind Sie sicher, dass Sie fortfahren möchten?",
    "warningUnsavedChanges": "Es gibt noch ungespeicherte Änderungen. Wenn Sie fortfahren gehen Ihre Änderungen verloren"
  },
  "yes": "Ja"
}
